import * as React from 'react';

const AnimatedSvgImage = () => {
  return (
    <svg
      className="animated"
      id="freepik_stories-design-process"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 750 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-design-process:not(.animated) .animable {opacity: 0;}svg#freepik_stories-design-process.animated #freepik--background-complete--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-design-process.animated #freepik--Shadow--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0.5s;opacity: 0}svg#freepik_stories-design-process.animated #freepik--Line--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-design-process.animated #freepik--Floor--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 2s;opacity: 0}svg#freepik_stories-design-process.animated #freepik--Rocket--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,1.5s Infinite  linear floating;animation-delay: 2s,3s;opacity: 0}svg#freepik_stories-design-process.animated #freepik--light-bulb--inject-12 {animation: 1s 1 forwards ease-in zoomIn,3s Infinite  linear heartbeat;animation-delay: 1s,2s;opacity: 0}svg#freepik_stories-design-process.animated #freepik--question-symbol--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft,3s Infinite  linear shake;animation-delay: 0s,1s;}svg#freepik_stories-design-process.animated #freepik--Gears--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-design-process.animated #freepik--Brushes--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-design-process.animated #freepik--character-2--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 1.5s;opacity: 0}svg#freepik_stories-design-process.animated #freepik--character-1--inject-12 {animation: 1s 1 forwards ease-in slideRight;animation-delay: 0.5s;opacity: 0}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes shake {                10%, 90% {                    transform: translate3d(-1px, 0, 0);                  }                  20%, 80% {                    transform: translate3d(2px, 0, 0);                  }                  30%, 50%, 70% {                    transform: translate3d(-4px, 0, 0);                  }                  40%, 60% {                    transform: translate3d(4px, 0, 0);                  }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }        .animator-hidden { display: none; }',
        }}
      />
      <g
        id="freepik--background-complete--inject-12"
        style={{ transformOrigin: '367.05px 229.97px 0px' }}
        className="animable animator-hidden"
      >
        <path
          d="M59.35,209.67V399.23H248.63Zm34.71,85.89,69,69H94.16Z"
          style={{
            fill: 'rgb(219, 219, 219)',
            transformOrigin: '153.99px 304.45px 0px',
          }}
          id="el4le0fda0hba"
          className="animable"
        />
        <path
          d="M59.35,209.68V399.23H248.63L66,216.36l-.84-.84Zm34.71,85.89,69,69H94.16Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '153.99px 304.455px 0px',
          }}
          id="elsg5819w2g7"
          className="animable"
        />
        <rect
          x="59.35"
          y="217.68"
          width="6.51"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '62.605px 218.135px 0px',
          }}
          id="el32n0rlw3akb"
          className="animable"
        />
        <rect
          x="59.35"
          y="221.89"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 222.345px 0px',
          }}
          id="elck4i5syzotf"
          className="animable"
        />
        <rect
          x="59.35"
          y="226.09"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 226.545px 0px',
          }}
          id="elha4zxs8t60b"
          className="animable"
        />
        <rect
          x="59.35"
          y="230.31"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 230.765px 0px',
          }}
          id="elrkntbpqocx"
          className="animable"
        />
        <rect
          x="59.35"
          y="234.52"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 234.975px 0px',
          }}
          id="el3vrfnhyw2fc"
          className="animable"
        />
        <rect
          x="59.35"
          y="238.72"
          width="3.83"
          height="0.92"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 239.18px 0px',
          }}
          id="elgw6t6y6vgi5"
          className="animable"
        />
        <rect
          x="59.35"
          y="242.94"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 243.395px 0px',
          }}
          id="elka4nej9re1"
          className="animable"
        />
        <rect
          x="59.35"
          y="247.15"
          width="6.51"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '62.605px 247.605px 0px',
          }}
          id="el0z0pfweo3ve"
          className="animable"
        />
        <rect
          x="59.35"
          y="251.37"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 251.825px 0px',
          }}
          id="elozj8f8z8u6q"
          className="animable"
        />
        <rect
          x="59.35"
          y="255.57"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 256.025px 0px',
          }}
          id="elx1drxpky9i"
          className="animable"
        />
        <rect
          x="59.35"
          y="259.78"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 260.235px 0px',
          }}
          id="elgdlu6gyf8gr"
          className="animable"
        />
        <rect
          x="59.35"
          y={264}
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 264.455px 0px',
          }}
          id="elomrbw0q031"
          className="animable"
        />
        <rect
          x="59.35"
          y="268.2"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 268.655px 0px',
          }}
          id="elb7w9i3ok0h8"
          className="animable"
        />
        <rect
          x="59.35"
          y="272.42"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 272.875px 0px',
          }}
          id="elbngykf2fqv"
          className="animable"
        />
        <rect
          x="59.35"
          y="276.63"
          width="6.51"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '62.605px 277.085px 0px',
          }}
          id="elxc7p5llrzdj"
          className="animable"
        />
        <rect
          x="59.35"
          y="280.83"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 281.285px 0px',
          }}
          id="elss405zj87uj"
          className="animable"
        />
        <rect
          x="59.35"
          y="285.05"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 285.505px 0px',
          }}
          id="el3fehqmdy452"
          className="animable"
        />
        <rect
          x="59.35"
          y="289.26"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 289.715px 0px',
          }}
          id="el35g1bca9gv"
          className="animable"
        />
        <rect
          x="59.35"
          y="293.46"
          width="3.83"
          height="0.92"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 293.92px 0px',
          }}
          id="ela3at8r1yvd"
          className="animable"
        />
        <rect
          x="59.35"
          y="297.68"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 298.135px 0px',
          }}
          id="elr1z4nznaubi"
          className="animable"
        />
        <rect
          x="59.35"
          y="301.89"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 302.345px 0px',
          }}
          id="elhewowgfagzh"
          className="animable"
        />
        <rect
          x="59.35"
          y="306.11"
          width="6.51"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '62.605px 306.565px 0px',
          }}
          id="elvbmrwk5g2q"
          className="animable"
        />
        <rect
          x="59.35"
          y="310.31"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 310.765px 0px',
          }}
          id="elzfvu8wdo5g"
          className="animable"
        />
        <rect
          x="59.35"
          y="314.52"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 314.975px 0px',
          }}
          id="el1tddg6f33p3"
          className="animable"
        />
        <rect
          x="59.35"
          y="318.74"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 319.195px 0px',
          }}
          id="eldydkpscvsf7"
          className="animable"
        />
        <rect
          x="59.35"
          y="322.94"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 323.395px 0px',
          }}
          id="elt9bw3g93ax"
          className="animable"
        />
        <rect
          x="59.35"
          y="327.15"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 327.605px 0px',
          }}
          id="el1yksn1aev1si"
          className="animable"
        />
        <rect
          x="59.35"
          y="331.37"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 331.825px 0px',
          }}
          id="elaqzq4uro7x6"
          className="animable"
        />
        <rect
          x="59.35"
          y="335.57"
          width="6.51"
          height="0.92"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '62.605px 336.03px 0px',
          }}
          id="elvcnby6r8v7l"
          className="animable"
        />
        <rect
          x="59.35"
          y="339.78"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 340.235px 0px',
          }}
          id="elsmhrgpxqbdg"
          className="animable"
        />
        <rect
          x="59.35"
          y={344}
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 344.455px 0px',
          }}
          id="elq3x2nz982tk"
          className="animable"
        />
        <rect
          x="59.35"
          y="348.22"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 348.675px 0px',
          }}
          id="elm52icqvbivp"
          className="animable"
        />
        <rect
          x="59.35"
          y="352.42"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 352.875px 0px',
          }}
          id="elk8grhetdh7m"
          className="animable"
        />
        <rect
          x="59.35"
          y="356.63"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 357.085px 0px',
          }}
          id="el6yknus2iohp"
          className="animable"
        />
        <rect
          x="59.35"
          y="360.85"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 361.305px 0px',
          }}
          id="eloyytdv78uii"
          className="animable"
        />
        <rect
          x="59.35"
          y="365.05"
          width="6.51"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '62.605px 365.505px 0px',
          }}
          id="elh0mtc585w8c"
          className="animable"
        />
        <rect
          x="59.35"
          y="369.26"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 369.715px 0px',
          }}
          id="elz3fi2ay737"
          className="animable"
        />
        <rect
          x="59.35"
          y="373.48"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 373.935px 0px',
          }}
          id="eldyellimv6c"
          className="animable"
        />
        <rect
          x="59.35"
          y="377.68"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 378.135px 0px',
          }}
          id="el5esoeddebi2"
          className="animable"
        />
        <rect
          x="59.35"
          y="381.89"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 382.345px 0px',
          }}
          id="eloiuu5olk6vt"
          className="animable"
        />
        <rect
          x="59.35"
          y="386.11"
          width="3.83"
          height="0.91"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 386.565px 0px',
          }}
          id="eluprlhnt0g"
          className="animable"
        />
        <rect
          x="59.35"
          y="390.31"
          width="3.83"
          height="0.92"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '61.265px 390.77px 0px',
          }}
          id="eld7oq0k6x50d"
          className="animable"
        />
        <path
          d="M669,302.36l5.5-8.87-2.71-1.69a2.48,2.48,0,0,1-1.16-2.33,11.62,11.62,0,0,0,0-1.56,2.49,2.49,0,0,1,1.3-2.26l2.82-1.51-4.94-9.2L667,276.45a2.49,2.49,0,0,1-2.59-.17,14,14,0,0,0-1.33-.82,2.5,2.5,0,0,1-1.31-2.26l.1-3.19-10.43-.33-.1,3.21a2.49,2.49,0,0,1-1.46,2.16l-.68.35c-.23.12-.45.25-.67.38a2.49,2.49,0,0,1-2.59,0l-2.74-1.7L637.71,283l2.73,1.69a2.47,2.47,0,0,1,1.15,2.33,11.62,11.62,0,0,0-.05,1.56,2.47,2.47,0,0,1-1.3,2.25l-2.82,1.51,4.94,9.21,2.82-1.51a2.47,2.47,0,0,1,2.59.16,15.19,15.19,0,0,0,1.32.82,2.47,2.47,0,0,1,1.31,2.25l-.1,3.2,10.44.33.1-3.21a2.5,2.5,0,0,1,1.45-2.15l.7-.35.66-.38a2.5,2.5,0,0,1,2.61,0Zm-8.84-6.59a8.55,8.55,0,1,1,3.5-11.58A8.54,8.54,0,0,1,660.14,295.77Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '656.085px 288.24px 0px',
          }}
          id="el79sowcill1k"
          className="animable"
        />
        <path
          d="M300.49,232.7l-3.65-6.34-1.94,1.12a1.75,1.75,0,0,1-1.83-.06c-.3-.2-.62-.38-.94-.55a1.72,1.72,0,0,1-1-1.54v-2.24h-7.31v2.24a1.72,1.72,0,0,1-1,1.54c-.32.17-.64.35-.94.55a1.75,1.75,0,0,1-1.83.06l-1.94-1.12-3.65,6.34,2,1.12a1.76,1.76,0,0,1,.85,1.62c0,.17,0,.35,0,.53s0,.36,0,.54a1.74,1.74,0,0,1-.85,1.61l-2,1.13,3.65,6.33,1.95-1.12a1.73,1.73,0,0,1,1.82.07,8.92,8.92,0,0,0,.95.54,1.75,1.75,0,0,1,1,1.55v2.24h7.31v-2.24a1.75,1.75,0,0,1,1-1.55,8.92,8.92,0,0,0,.95-.54,1.73,1.73,0,0,1,1.82-.07l1.95,1.12,3.65-6.33-1.94-1.12a1.75,1.75,0,0,1-.85-1.61c0-.18,0-.36,0-.55s0-.36,0-.53a1.74,1.74,0,0,1,.85-1.62Zm-7,3.27a6,6,0,1,1-6-6A6,6,0,0,1,293.5,236Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '287.485px 235.975px 0px',
          }}
          id="eli6fvmyjvgpl"
          className="animable"
        />
        <path
          d="M103.5,131.54A28.5,28.5,0,1,0,132,160,28.5,28.5,0,0,0,103.5,131.54Zm0,41.8A13.31,13.31,0,1,1,116.81,160,13.3,13.3,0,0,1,103.5,173.34Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '103.5px 160.04px 0px',
          }}
          id="el7e1e4l2nly"
          className="animable"
        />
        <polygon
          points="108.98 132.72 98.03 132.72 98.63 124.97 108.38 124.97 108.98 132.72"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '103.505px 128.845px 0px',
          }}
          id="elkyzvublyhz"
          className="animable"
        />
        <polygon
          points="88.13 136.41 80.38 144.16 75.32 138.25 82.22 131.36 88.13 136.41"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '81.725px 137.76px 0px',
          }}
          id="elrsvxdmw0odf"
          className="animable"
        />
        <polygon
          points="75.99 153.77 75.99 164.73 68.23 164.12 68.23 154.38 75.99 153.77"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '72.11px 159.25px 0px',
          }}
          id="elerys7ublp6b"
          className="animable"
        />
        <polygon
          points="79.68 174.63 87.43 182.38 81.52 187.43 74.63 180.54 79.68 174.63"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '81.03px 181.03px 0px',
          }}
          id="elf0vc08tq4uh"
          className="animable"
        />
        <polygon
          points="97.04 186.76 108 186.76 107.39 194.52 97.65 194.52 97.04 186.76"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '102.52px 190.64px 0px',
          }}
          id="el5nn96iqqdj"
          className="animable"
        />
        <polygon
          points="117.89 183.07 125.64 175.32 130.7 181.24 123.81 188.13 117.89 183.07"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '124.295px 181.725px 0px',
          }}
          id="elqrezut9h7nc"
          className="animable"
        />
        <polygon
          points="130.03 165.72 130.03 154.76 137.79 155.36 137.79 165.11 130.03 165.72"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '133.91px 160.24px 0px',
          }}
          id="el26328y67l3a"
          className="animable"
        />
        <polygon
          points="126.34 144.86 118.59 137.11 124.5 132.06 131.4 138.95 126.34 144.86"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '124.995px 138.46px 0px',
          }}
          id="el9otcldw2c4g"
          className="animable"
        />
        <path
          d="M495,67.29a28.49,28.49,0,1,0,28.49,28.49A28.48,28.48,0,0,0,495,67.29Zm0,41.79a13.31,13.31,0,1,1,13.31-13.3A13.3,13.3,0,0,1,495,109.08Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '495px 95.7804px 0px',
          }}
          id="el9d629miz3n8"
          className="animable"
        />
        <polygon
          points="500.43 68.47 489.47 68.47 490.08 60.71 499.82 60.71 500.43 68.47"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '494.95px 64.59px 0px',
          }}
          id="el3mali8cmzi"
          className="animable"
        />
        <polygon
          points="479.57 72.16 471.82 79.91 466.77 73.99 473.66 67.1 479.57 72.16"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '473.17px 73.505px 0px',
          }}
          id="elqhoc6oyj09c"
          className="animable"
        />
        <polygon
          points="467.44 89.52 467.44 100.47 459.68 99.87 459.68 90.12 467.44 89.52"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '463.56px 94.995px 0px',
          }}
          id="elvnom3ek4vyc"
          className="animable"
        />
        <polygon
          points="471.13 110.37 478.88 118.12 472.96 123.17 466.07 116.28 471.13 110.37"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '472.475px 116.77px 0px',
          }}
          id="el1e8heedvv1n"
          className="animable"
        />
        <polygon
          points="488.49 122.51 499.44 122.51 498.84 130.26 489.09 130.26 488.49 122.51"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '493.965px 126.385px 0px',
          }}
          id="el71h5vbrysio"
          className="animable"
        />
        <polygon
          points="509.34 118.81 517.09 111.07 522.14 116.98 515.25 123.87 509.34 118.81"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '515.74px 117.47px 0px',
          }}
          id="elb2h7oa8l86v"
          className="animable"
        />
        <polygon
          points="521.48 101.46 521.48 90.5 529.23 91.11 529.23 100.85 521.48 101.46"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '525.355px 95.98px 0px',
          }}
          id="elyc7wjjqlmg"
          className="animable"
        />
        <polygon
          points="517.78 80.6 510.04 72.86 515.95 67.8 522.84 74.69 517.78 80.6"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '516.44px 74.2px 0px',
          }}
          id="elf6pxsjun8q"
          className="animable"
        />
      </g>
      <g
        id="freepik--Shadow--inject-12"
        style={{ transformOrigin: '375px 437.76px 0px' }}
        className="animable animator-active"
      >
        <ellipse
          cx={375}
          cy="437.76"
          rx="277.18"
          ry="21.13"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '375px 437.76px 0px',
          }}
          id="elu3w63r3ciwa"
          className="animable"
        />
      </g>
      <g
        id="freepik--Line--inject-12"
        style={{ transformOrigin: '375px 231.775px 0px' }}
        className="animable animator-hidden"
      >
        <path
          d="M168.45,399.18h-30v-209a125.81,125.81,0,0,1,251.62,0v62a95.74,95.74,0,1,0,191.48,0V129.41h30V252.24a125.74,125.74,0,1,1-251.48,0v-62a95.81,95.81,0,1,0-191.62,0Z"
          style={{ fill: '#F53B57', transformOrigin: '375px 231.775px 0px' }}
          id="elh7l0rfreztc"
          className="animable"
        />
        <g id="elvngj76s0mv9">
          <path
            d="M486.08,348v30h-.27A125.88,125.88,0,0,1,360.07,252.24v-62a95.92,95.92,0,0,0-95.81-95.81h-.34v-30h.34A126,126,0,0,1,390.07,190.22v62A95.85,95.85,0,0,0,485.81,348Z"
            style={{ opacity: '0.2', transformOrigin: '375px 221.215px 0px' }}
            className="animable"
            id="eld8es1f2l7y5"
          />
        </g>
      </g>
      <g
        id="freepik--Floor--inject-12"
        style={{ transformOrigin: '375px 399.18px 0px' }}
        className="animable animator-hidden"
      >
        <polygon
          points="43.42 399.18 126.31 398.94 209.21 398.85 375 398.68 540.79 398.85 623.69 398.94 706.58 399.18 623.69 399.43 540.79 399.51 375 399.68 209.21 399.51 126.31 399.42 43.42 399.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375px 399.18px 0px',
          }}
          id="elwbiuywg2pch"
          className="animable"
        />
      </g>
      <g
        id="freepik--Rocket--inject-12"
        style={{ transformOrigin: '596.98px 224.795px 0px' }}
        className="animable"
      >
        <g id="elmc8ps7coah">
          <circle
            cx="517.96"
            cy="366.16"
            r="5.53"
            style={{
              fill: '#F53B57',
              opacity: '0.6',
              transformOrigin: '517.96px 366.16px 0px',
            }}
            className="animable"
            id="elhgtw64wzgav"
          />
        </g>
        <g id="elwizot62l5d">
          <path
            d="M530.21,355.61a2.7,2.7,0,1,1-2.7-2.7A2.7,2.7,0,0,1,530.21,355.61Z"
            style={{
              fill: '#F53B57',
              opacity: '0.6',
              transformOrigin: '527.51px 355.61px 0px',
            }}
            className="animable"
            id="eluel2vvxm2k"
          />
        </g>
        <g id="elahmxr2a2w7j">
          <path
            d="M648.44,363.49a2.69,2.69,0,1,1-2.69-2.7A2.68,2.68,0,0,1,648.44,363.49Z"
            style={{
              fill: '#F53B57',
              opacity: '0.6',
              transformOrigin: '645.75px 363.48px 0px',
            }}
            className="animable"
            id="elsbya2kuczn"
          />
        </g>
        <g id="eltk0uudb7s5k">
          <path
            d="M702.38,388.08a2.7,2.7,0,1,1-2.7-2.7A2.7,2.7,0,0,1,702.38,388.08Z"
            style={{
              fill: '#F53B57',
              opacity: '0.6',
              transformOrigin: '699.68px 388.08px 0px',
            }}
            className="animable"
            id="elfo4kvajr30e"
          />
        </g>
        <g id="elagfh5h2qgl">
          <path
            d="M698.25,396a3.21,3.21,0,0,1-3.21,3.21H494.79a3.21,3.21,0,0,1,0-6.42,3.16,3.16,0,0,1,.76.09,6.34,6.34,0,0,1,10.86-4.43l.06,0a11.66,11.66,0,0,1-.06-1.18,12,12,0,0,1,17.22-10.74,8.53,8.53,0,0,1,16.47-2.6,12,12,0,0,1,10.12-5.58,12.35,12.35,0,0,1,2.29.22A16.18,16.18,0,0,1,579,353.45a3.23,3.23,0,0,1,2.85-1.74,3.38,3.38,0,0,1,1.24.24l3-80.3h17.64l3,80.3a3.33,3.33,0,0,1,1.23-.24,3.21,3.21,0,0,1,2.85,1.74,16.19,16.19,0,0,1,26.5,15.05,12.26,12.26,0,0,1,2.29-.22,12,12,0,0,1,10.12,5.58,8.53,8.53,0,0,1,16.47,2.6,11.95,11.95,0,0,1,17.21,10.74,11.64,11.64,0,0,1,0,1.18l0,0a6.34,6.34,0,0,1,10.86,4.43,3.25,3.25,0,0,1,.77-.09A3.21,3.21,0,0,1,698.25,396Z"
            style={{
              fill: '#F53B57',
              opacity: '0.6',
              transformOrigin: '594.915px 335.43px 0px',
            }}
            className="animable"
            id="elmg7ox05t5d"
          />
        </g>
        <path
          d="M553.93,173.15c-.86,0-33.1,14.88-35,51.52-1.76,33.69,21.53,65.68,24.54,63.56,3.68-2.6-2.58-23.58,4.58-47.59,2.53-8.51,13.63-16.07,13.63-16.07Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '540.258px 230.74px 0px',
          }}
          id="el96ng2dpp2p"
          className="animable"
        />
        <path
          d="M543.13,288.83a2.25,2.25,0,0,1-1.06-.33c-5.61-3.1-25.28-32.45-23.64-63.86a59.68,59.68,0,0,1,18-39.82c8.53-8.43,16.84-12.17,17.46-12.17h.44l.06.43,7.8,51.73L562,225c-.11.07-11,7.55-13.45,15.79C544.3,255,544.78,268.19,545.1,277c.23,6.53.37,10.48-1.34,11.69A1.12,1.12,0,0,1,543.13,288.83Zm10.4-115c-4,1.88-32.33,16.75-34.11,50.85-1.58,30.44,17.82,60,23.14,62.92.41.23.6.21.62.2,1.28-.9,1.12-5.28.92-10.84-.32-8.82-.8-22.16,3.47-36.48,2.37-8,11.84-14.93,13.57-16.16Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '540.262px 230.742px 0px',
          }}
          id="eleael3cd2uwn"
          className="animable"
        />
        <g id="eld9845pxqu9">
          <path
            d="M561.69,224.57a50.59,50.59,0,0,0-8.83,8c-4.8-10.71-13.74-30.69-19.52-43.63,9.45-10.92,20.1-15.74,20.59-15.74Z"
            style={{
              opacity: '0.1',
              transformOrigin: '547.515px 202.885px 0px',
            }}
            className="animable"
            id="el3b6o4c1f69y"
          />
        </g>
        <path
          d="M636,173.21c.87,0,33.08,14.93,34.94,51.57,1.7,33.69-21.64,65.64-24.64,63.52-3.67-2.6,2.61-23.57-4.51-47.59-2.52-8.52-13.61-16.09-13.61-16.09Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '649.604px 230.805px 0px',
          }}
          id="elu6klqz5qg3j"
          className="animable"
        />
        <path
          d="M646.61,288.9a1.07,1.07,0,0,1-.63-.19c-1.71-1.21-1.57-5.16-1.32-11.69.33-8.76.82-22-3.38-36.17-2.44-8.24-13.31-15.74-13.42-15.82l-.26-.17,0-.31,7.89-51.84H636c.62,0,8.93,3.75,17.45,12.19a59.67,59.67,0,0,1,18,39.85c1.6,31.41-18.12,60.74-23.73,63.83A2.35,2.35,0,0,1,646.61,288.9Zm-17.92-64.51c1.73,1.23,11.19,8.22,13.55,16.18,4.25,14.32,3.75,27.66,3.42,36.49-.21,5.55-.37,9.93.9,10.83,0,0,.21,0,.62-.19,5.32-2.93,24.77-32.45,23.23-62.89-1.73-34.11-30-49-34-50.9Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '649.571px 230.805px 0px',
          }}
          id="elecuchzeoz3"
          className="animable"
        />
        <path
          d="M665.16,202c-2.77.5-5.87,1.43-7.61,3.14-3.72,3.62,1.11,23.66-5.57,26.54S648.63,227,643.5,228c-2.34.48-3.46,3.93-4.4,7.32a48,48,0,0,0-11-10.73L636,173.21C636.62,173.21,655.36,181.82,665.16,202Z"
          style={{ fill: '#F53B57', transformOrigin: '646.63px 204.265px 0px' }}
          id="elxazwh03kzxb"
          className="animable"
        />
        <g id="el3jmoc8d6fk">
          <path
            d="M656.66,189.11l-19.54,43.65a51.23,51.23,0,0,0-9-8.14L636,173.21C636.46,173.21,647.2,178.09,656.66,189.11Z"
            style={{
              opacity: '0.1',
              transformOrigin: '642.39px 202.985px 0px',
            }}
            className="animable"
            id="el5304on5spb8"
          />
        </g>
        <path
          d="M619.33,257.44l-48.64,0s-22.92-41-20.2-89.82c1.37-24.38,7.74-48.93,15.41-69.24,10.55-28.06,23.6-48,29.26-48s18.67,19.93,29.21,48c7.62,20.32,14,44.88,15.29,69.26C642.3,216.5,619.33,257.44,619.33,257.44Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '595.069px 153.91px 0px',
          }}
          id="elm2nvvv6w4f"
          className="animable"
        />
        <path
          d="M624.19,161.33a28.05,28.05,0,1,1-28-28.07A28.06,28.06,0,0,1,624.19,161.33Z"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '596.14px 161.31px 0px',
          }}
          id="eljcot7os9rto"
          className="animable"
        />
        <path
          d="M623.19,158.48a28.05,28.05,0,1,1-28-28.07A28,28,0,0,1,623.19,158.48Z"
          style={{ fill: '#F53B57', transformOrigin: '595.14px 158.46px 0px' }}
          id="el7sl9wumfik"
          className="animable"
        />
        <path
          d="M614.6,158.45A19.46,19.46,0,1,1,595.14,139,19.46,19.46,0,0,1,614.6,158.45Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '595.14px 158.46px 0px',
          }}
          id="elwdw58p5othb"
          className="animable"
        />
        <path
          d="M614.6,158.45a19.17,19.17,0,0,1-1.32,7.05L602.2,176.59a19.56,19.56,0,0,1-12.26.6l23.94-23.94A19,19,0,0,1,614.6,158.45Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '602.27px 165.575px 0px',
          }}
          id="elzjl4nupiiq"
          className="animable"
        />
        <path
          d="M598,139.21l-22.1,22.1a19.12,19.12,0,0,1-.21-2.85A19.46,19.46,0,0,1,595.15,139,20.67,20.67,0,0,1,598,139.21Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '586.845px 150.155px 0px',
          }}
          id="elyln8kda3rsm"
          className="animable"
        />
        <path
          d="M612.17,149l-26.44,26.44a16.62,16.62,0,0,1-1.49-.92l27-27C611.58,148,611.88,148.52,612.17,149Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '598.205px 161.48px 0px',
          }}
          id="elr86zlqa27f8"
          className="animable"
        />
        <path
          d="M624.37,98.39l-58.47,0c10.55-28.06,23.6-48,29.26-48S613.83,70.32,624.37,98.39Z"
          style={{ fill: '#F53B57', transformOrigin: '595.135px 74.39px 0px' }}
          id="elg2wq2rlucr"
          className="animable"
        />
        <path
          d="M576,92.31a1.64,1.64,0,1,1-1.64-1.64A1.64,1.64,0,0,1,576,92.31Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '574.36px 92.31px 0px',
          }}
          id="elkqa8d5u77l"
          className="animable"
        />
        <path
          d="M586.37,92.32a1.64,1.64,0,1,1-1.64-1.64A1.63,1.63,0,0,1,586.37,92.32Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '584.73px 92.32px 0px',
          }}
          id="elf3g2nupxgkb"
          className="animable"
        />
        <path
          d="M596.77,92.33a1.64,1.64,0,1,1-1.63-1.64A1.63,1.63,0,0,1,596.77,92.33Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '595.13px 92.33px 0px',
          }}
          id="elcnjll9unfba"
          className="animable"
        />
        <path
          d="M607.17,92.34a1.64,1.64,0,1,1-1.63-1.64A1.63,1.63,0,0,1,607.17,92.34Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '605.53px 92.34px 0px',
          }}
          id="elfe06z6menp"
          className="animable"
        />
        <path
          d="M617.57,92.34a1.64,1.64,0,1,1-1.63-1.64A1.63,1.63,0,0,1,617.57,92.34Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '615.93px 92.34px 0px',
          }}
          id="elmq92kpmaex"
          className="animable"
        />
        <path
          d="M575.9,249.93a1.64,1.64,0,1,1-1.64-1.64A1.64,1.64,0,0,1,575.9,249.93Z"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '574.26px 249.93px 0px',
          }}
          id="ellaayxnvhq"
          className="animable"
        />
        <path
          d="M586.3,249.94a1.64,1.64,0,1,1-1.63-1.64A1.63,1.63,0,0,1,586.3,249.94Z"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '584.66px 249.94px 0px',
          }}
          id="eliz2sjdxlyke"
          className="animable"
        />
        <path
          d="M596.7,250a1.64,1.64,0,1,1-1.63-1.64A1.63,1.63,0,0,1,596.7,250Z"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '595.06px 250px 0px',
          }}
          id="elyxunjnaccwh"
          className="animable"
        />
        <path
          d="M607.1,250a1.64,1.64,0,1,1-1.63-1.64A1.63,1.63,0,0,1,607.1,250Z"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '605.46px 250px 0px',
          }}
          id="elaj3676o5326"
          className="animable"
        />
        <path
          d="M617.51,250a1.64,1.64,0,1,1-1.64-1.64A1.65,1.65,0,0,1,617.51,250Z"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '615.87px 250px 0px',
          }}
          id="elqqn17w72nsp"
          className="animable"
        />
        <polygon
          points="614.84 272.06 575.28 272.03 573.44 257.42 616.71 257.45 614.84 272.06"
          style={{ fill: '#F53B57', transformOrigin: '595.075px 264.74px 0px' }}
          id="el1x32ddu3ezwh"
          className="animable"
        />
        <g id="elo4mp1bc9l9g">
          <polygon
            points="616.7 257.45 615.79 264.57 574.14 263.01 573.44 257.42 616.7 257.45"
            style={{
              opacity: '0.1',
              transformOrigin: '595.07px 260.995px 0px',
            }}
            className="animable"
            id="eliu8lqoooukm"
          />
        </g>
        <g id="elo6487qkamj">
          <path
            d="M593.48,58.67c-3.66,7.91-7.19,15.81-10.59,23.77-1.64,4-3.37,8-4.9,12l-1.2,3c-.4,1-.76,2-1.15,3-.74,2-1.54,4-2.23,6.06l-2.16,6.09c-.73,2-1.3,4.1-2,6.14l-1,3.07-.89,3.1-.89,3.11c-.3,1-.66,2.05-.9,3.1-2.24,8.33-4,16.76-5.42,25.37a120.49,120.49,0,0,1,2.38-26.08c.4-2.15.94-4.27,1.45-6.41l.77-3.19.89-3.16c.62-2.1,1.21-4.21,1.91-6.28l2.11-6.22c.73-2.06,1.57-4.08,2.35-6.12S573.61,95,574.5,93s1.75-4,2.7-6,1.85-4,2.87-5.88A171.42,171.42,0,0,1,593.48,58.67Z"
            style={{
              fill: 'rgb(255, 255, 255)',
              opacity: '0.5',
              transformOrigin: '576.805px 107.575px 0px',
            }}
            className="animable"
            id="elheaiiq0sjzg"
          />
        </g>
        <polygon
          points="647.35 369.16 643.45 369.88 642.58 373.98 641.71 369.88 637.82 369.15 641.7 368.21 642.58 364.33 643.47 368.21 647.35 369.16"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '642.585px 369.155px 0px',
          }}
          id="elo6t0r0gkgq9"
          className="animable"
        />
        <polygon
          points="609.48 336.25 605.59 336.96 604.72 341.07 603.85 336.96 599.96 336.24 603.83 335.3 604.72 331.42 605.6 335.3 609.48 336.25"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '604.72px 336.245px 0px',
          }}
          id="elkqsvubr6kgl"
          className="animable"
        />
        <polygon
          points="591.97 296.79 588.07 297.51 587.2 301.61 586.33 297.51 582.44 296.79 586.32 295.84 587.2 291.96 588.09 295.84 591.97 296.79"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '587.205px 296.785px 0px',
          }}
          id="elsucy17hiizd"
          className="animable"
        />
        <polygon
          points="552.9 376.97 550.73 377.37 550.24 379.67 549.76 377.37 547.58 376.97 549.75 376.44 550.24 374.27 550.74 376.44 552.9 376.97"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '550.24px 376.97px 0px',
          }}
          id="ele1vt2t0brsf"
          className="animable"
        />
        <polygon
          points="669.98 383.81 667.81 384.21 667.32 386.51 666.83 384.21 664.66 383.81 666.82 383.28 667.32 381.12 667.82 383.28 669.98 383.81"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '667.32px 383.815px 0px',
          }}
          id="elluik1wkctz"
          className="animable"
        />
        <polygon
          points="522.96 391.85 520.78 392.25 520.3 394.55 519.81 392.25 517.64 391.85 519.8 391.32 520.3 389.15 520.79 391.32 522.96 391.85"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '520.3px 391.85px 0px',
          }}
          id="el5lgt1tcgveb"
          className="animable"
        />
        <polygon
          points="617.61 389.94 615.43 390.35 614.95 392.64 614.46 390.35 612.28 389.94 614.45 389.41 614.95 387.25 615.44 389.41 617.61 389.94"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '614.945px 389.945px 0px',
          }}
          id="elpiitrjxaube"
          className="animable"
        />
        <polygon
          points="601.68 330.01 599.5 330.41 599.02 332.7 598.53 330.41 596.36 330 598.52 329.48 599.02 327.31 599.51 329.48 601.68 330.01"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '599.02px 330.005px 0px',
          }}
          id="ellh83w9wmdfj"
          className="animable"
        />
        <path
          d="M675.13,388.77a.63.63,0,0,0,0,1.26A.63.63,0,0,0,675.13,388.77Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '675.13px 389.4px 0px',
          }}
          id="el3nxu0koqous"
          className="animable"
        />
        <path
          d="M593.26,322.05a.63.63,0,0,0,0,1.26A.63.63,0,0,0,593.26,322.05Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '593.26px 322.68px 0px',
          }}
          id="elau3i1sd6a99"
          className="animable"
        />
        <path
          d="M539.45,391.85a.63.63,0,0,0,0,1.26A.63.63,0,0,0,539.45,391.85Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '539.45px 392.48px 0px',
          }}
          id="elzhprhhjb5th"
          className="animable"
        />
        <path
          d="M579.42,383.18a.63.63,0,0,0,0,1.26A.63.63,0,0,0,579.42,383.18Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '579.42px 383.81px 0px',
          }}
          id="elusde9040bed"
          className="animable"
        />
        <path
          d="M659.33,377.43a.45.45,0,0,0,0,.89A.45.45,0,0,0,659.33,377.43Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '659.33px 377.875px 0px',
          }}
          id="elxmv72cki1qp"
          className="animable"
        />
        <path
          d="M604.19,370.74a.45.45,0,0,0,0,.89A.45.45,0,0,0,604.19,370.74Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '604.19px 371.185px 0px',
          }}
          id="elnv07ggits5s"
          className="animable"
        />
        <path
          d="M563.83,362a.45.45,0,0,0,0,.89A.45.45,0,0,0,563.83,362Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '563.83px 362.445px 0px',
          }}
          id="el8x97oi520dg"
          className="animable"
        />
        <path
          d="M632.88,363.84a1.21,1.21,0,0,0,0,2.42A1.21,1.21,0,0,0,632.88,363.84Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '632.88px 365.05px 0px',
          }}
          id="elyho3n90z0ik"
          className="animable"
        />
        <path
          d="M569.55,357.92a1.21,1.21,0,0,0,0,2.42A1.21,1.21,0,0,0,569.55,357.92Z"
          style={{
            fill: 'rgb(252, 252, 252)',
            transformOrigin: '569.55px 359.13px 0px',
          }}
          id="el6cy6cd0frg"
          className="animable"
        />
      </g>
      <g
        id="freepik--light-bulb--inject-12"
        style={{ transformOrigin: '374.82px 177.16px 0px' }}
        className="animable"
      >
        <path
          d="M432,167.46c-4.39,37.44-28.44,44.32-32.47,54.31-2.16,5.4-5,19.14-5,19.14H355.42s-2.83-13.75-5-19.15c-4-10-28.08-16.88-32.43-54.32C315.11,142.83,333.61,104,375,104S434.88,142.85,432,167.46Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '374.995px 172.455px 0px',
          }}
          id="el9uawgt1e0ii"
          className="animable"
        />
        <g id="el026vuk1pxj2n">
          <rect
            x="359.07"
            y="180.69"
            width={1}
            height="63.3"
            style={{
              fill: 'rgb(255, 255, 255)',
              transformOrigin: '359.57px 212.34px 0px',
              transform: 'rotate(-10.56deg)',
            }}
            className="animable"
            id="elf8d9o524xm"
          />
        </g>
        <g id="eluxs57yg1jm">
          <rect
            x="358.76"
            y="211.85"
            width="63.3"
            height={1}
            style={{
              fill: 'rgb(255, 255, 255)',
              transformOrigin: '390.41px 212.35px 0px',
              transform: 'rotate(-79.41deg)',
            }}
            className="animable"
            id="el775aftcrf7l"
          />
        </g>
        <path
          d="M375,201.68h0c-3.53,0-6.78-3.37-9-7.64a4.64,4.64,0,0,1-3.38,2h0c-5.66,0-8-11.88-8.06-12.39l.49-.09c0,.12,2.32,12,7.57,12h0a4.34,4.34,0,0,0,3.13-2,26.35,26.35,0,0,1-2.93-11.1c0-3.28,1.16-5.08,3.25-5.08h0a3.3,3.3,0,0,1,3,1.71c1.72,3,.44,9.21-1.84,13.15a13.14,13.14,0,0,1-.88,1.35c2.18,4.21,5.32,7.59,8.67,7.59h0c2.52,0,5-2,7.09-5.51q.3-.51.57-1a11.07,11.07,0,0,1-1.47-2c-2.38-4.13-2.88-10.25-1.08-13.36a3.33,3.33,0,0,1,2.94-1.87h0a2.53,2.53,0,0,1,2.26,1.4c1.68,2.91.67,10.2-2,15.74a5.9,5.9,0,0,0,4.23,1.83c4.51,0,7.87-11.91,7.9-12l.49.13c-.15.51-3.51,12.4-8.39,12.4h0A6.38,6.38,0,0,1,383,195c-.16.32-.33.63-.5.93C381,198.54,378.46,201.68,375,201.68Zm8.05-23.8a2.83,2.83,0,0,0-2.51,1.62c-1.69,2.92-1.18,8.93,1.09,12.87a10.42,10.42,0,0,0,1.27,1.77c2.59-5.38,3.57-12.34,2-15.11a2,2,0,0,0-1.82-1.15Zm-17,0c-2.39,0-2.75,2.87-2.75,4.58a26,26,0,0,0,2.79,10.63c.24-.34.47-.7.7-1.1,2.21-3.82,3.47-9.82,1.84-12.65A2.79,2.79,0,0,0,366,177.88Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '375.255px 189.529px 0px',
          }}
          id="elvr9p7yxtwzn"
          className="animable"
        />
        <rect
          x="350.85"
          y="239.23"
          width="48.27"
          height="9.43"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '374.985px 243.945px 0px',
          }}
          id="el4y4h94jmhax"
          className="animable"
        />
        <rect
          x="350.85"
          y="250.19"
          width="48.27"
          height="9.43"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '374.985px 254.905px 0px',
          }}
          id="elv0p2c247xjh"
          className="animable"
        />
        <rect
          x="350.85"
          y="261.15"
          width="48.27"
          height="9.43"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '374.985px 265.865px 0px',
          }}
          id="el0eqc57o8w6yq"
          className="animable"
        />
        <g id="elwx6gv45tl1l">
          <path
            d="M327.1,165.58a34.78,34.78,0,0,1,.54-9.65,61.4,61.4,0,0,1,2.45-9.41,59.77,59.77,0,0,1,9.23-17.23,43.39,43.39,0,0,1,15.15-12.57,35.4,35.4,0,0,1,19-3.58,63.62,63.62,0,0,0-9.18,2.35,46.27,46.27,0,0,0-8.34,4,50.37,50.37,0,0,0-13.5,12.29A78.38,78.38,0,0,0,333,147.67c-1.27,2.85-2.45,5.76-3.45,8.74A55.75,55.75,0,0,0,327.1,165.58Z"
            style={{
              fill: 'rgb(255, 255, 255)',
              opacity: '0.5',
              transformOrigin: '350.224px 139.288px 0px',
            }}
            className="animable"
            id="eldx0gg2ms5me"
          />
        </g>
        <path
          d="M375.36,98.35a48.42,48.42,0,0,1-.5-7.3,47.19,47.19,0,0,1,.5-7.31,46,46,0,0,1,.5,7.31A47.15,47.15,0,0,1,375.36,98.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375.36px 91.045px 0px',
          }}
          id="elyo1qibnsxl"
          className="animable"
        />
        <path
          d="M341.84,107a47.08,47.08,0,0,1-4.09-6.07,46.07,46.07,0,0,1-3.22-6.58,47.53,47.53,0,0,1,4.09,6.08A48.17,48.17,0,0,1,341.84,107Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '338.185px 100.675px 0px',
          }}
          id="elrq8dywrwr0m"
          className="animable"
        />
        <path
          d="M317.15,131.33a46.07,46.07,0,0,1-6.58-3.22,47.11,47.11,0,0,1-6.08-4.08,46.07,46.07,0,0,1,6.58,3.22A48.16,48.16,0,0,1,317.15,131.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '310.82px 127.68px 0px',
          }}
          id="elsz8o8rv42o"
          className="animable"
        />
        <path
          d="M307.91,164.71a53.61,53.61,0,0,1-14.61,0,53.61,53.61,0,0,1,14.61,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '300.605px 164.71px 0px',
          }}
          id="elwlebu2sjr3"
          className="animable"
        />
        <path
          d="M316.61,198.24a49,49,0,0,1-6.08,4.09,48.29,48.29,0,0,1-6.58,3.22,47.19,47.19,0,0,1,6.08-4.09A47.73,47.73,0,0,1,316.61,198.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '310.28px 201.895px 0px',
          }}
          id="elqov5siyghnf"
          className="animable"
        />
        <path
          d="M432.49,199.18a48.29,48.29,0,0,1,6.58,3.22,47.08,47.08,0,0,1,6.07,4.09,53.7,53.7,0,0,1-12.65-7.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '438.815px 202.835px 0px',
          }}
          id="el4kwwwzabkc2"
          className="animable"
        />
        <path
          d="M441.72,165.8a48.55,48.55,0,0,1,7.31-.5,47.27,47.27,0,0,1,7.31.5,46.07,46.07,0,0,1-7.31.5A48.55,48.55,0,0,1,441.72,165.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '449.03px 165.8px 0px',
          }}
          id="elsf29291fq5q"
          className="animable"
        />
        <path
          d="M433,132.27a48.16,48.16,0,0,1,6.08-4.08,46.07,46.07,0,0,1,6.58-3.22,47.11,47.11,0,0,1-6.08,4.08A46.07,46.07,0,0,1,433,132.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '439.33px 128.62px 0px',
          }}
          id="elbpq3uorqkk8"
          className="animable"
        />
        <path
          d="M408.74,107.59A48.29,48.29,0,0,1,412,101a47.19,47.19,0,0,1,4.09-6.08,48.29,48.29,0,0,1-3.22,6.58A49,49,0,0,1,408.74,107.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '412.415px 101.255px 0px',
          }}
          id="elwsc43bdbv4m"
          className="animable"
        />
      </g>
      <g
        id="freepik--question-symbol--inject-12"
        style={{ transformOrigin: '158.904px 205.53px 0px' }}
        className="animable"
      >
        <path
          d="M126.62,239.47a61.74,61.74,0,0,1,4.29-23.61q4.29-10.47,17.71-18.25,4-2.42,9.93-5.5a80.21,80.21,0,0,0,11.53-7.37,42.5,42.5,0,0,0,9.53-10.06,23.22,23.22,0,0,0,3.89-13.28,21.93,21.93,0,0,0-2.15-9.93,22.68,22.68,0,0,0-5.63-7.24,23.32,23.32,0,0,0-8.19-4.43,31.68,31.68,0,0,0-9.52-1.48,27.47,27.47,0,0,0-10.73,2,36.68,36.68,0,0,0-8.72,5.09,43.07,43.07,0,0,0-7,7,76.61,76.61,0,0,0-5.23,7.38L103,143.69a52.13,52.13,0,0,1,9.26-14.76,56.61,56.61,0,0,1,13.14-10.86,61.59,61.59,0,0,1,16-6.71,68.62,68.62,0,0,1,17.7-2.28,70.45,70.45,0,0,1,20.12,3A51,51,0,0,1,197,121.42a48.55,48.55,0,0,1,12.88,16.5q5,10.07,5,24a51.53,51.53,0,0,1-2,15.16A42.33,42.33,0,0,1,207.11,189a50.34,50.34,0,0,1-8.86,9.66A101.06,101.06,0,0,1,186.72,207q-5.37,3.23-10.74,6.17a64.1,64.1,0,0,0-9.79,6.58,32,32,0,0,0-7.24,8.31,21.82,21.82,0,0,0-2.82,11.41Zm.54,62.51V265h29.78v37Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '158.944px 205.54px 0px',
          }}
          id="elm4dczobo3v"
          className="animable"
        />
        <path
          d="M128.12,240h-2v-.5c0-.51,0-1,0-1.51l1,0c0,.32,0,.66,0,1h1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '127.12px 238.995px 0px',
          }}
          id="elxtqlv68oxj"
          className="animable"
        />
        <path
          d="M127.25,235l-1-.06c.06-1,.15-2,.25-3l1,.1Q127.34,233.46,127.25,235Zm.62-6-1-.15c.15-1,.33-2,.52-3l1,.19C128.19,227,128,228,127.87,229Zm1.18-5.89-1-.24c.25-1,.53-2,.84-2.94l1,.3C129.57,221.16,129.3,222.14,129.05,223.1Zm1.8-5.72-.94-.35.54-1.36c.2-.5.42-1,.65-1.47l.9.43c-.22.47-.43.94-.62,1.42S131,216.94,130.85,217.38Zm2.58-5.35-.85-.53a29.93,29.93,0,0,1,1.74-2.53l.8.6C134.51,210.37,133.94,211.2,133.43,212Zm3.59-4.75-.73-.67c.66-.73,1.39-1.47,2.15-2.18l.68.73C138.38,205.85,137.68,206.57,137,207.28Zm4.35-4.1-.63-.77c.76-.63,1.58-1.25,2.42-1.86l.59.81C142.92,202,142.12,202.57,141.37,203.18Zm4.85-3.51-.54-.84c.84-.54,1.71-1.08,2.6-1.6l.5.87C147.91,198.61,147,199.14,146.22,199.67Zm5.18-3.1-.5-.87,2.65-1.48.48.88Zm5.29-2.91-.47-.88,2.09-1.11.58-.3.47.88-.58.31Zm5.33-2.9-.5-.86c.86-.51,1.71-1,2.56-1.57l.54.84C163.76,189.72,162.89,190.25,162,190.76Zm5.14-3.28-.57-.82c.81-.57,1.63-1.15,2.44-1.76l.6.81C168.81,186.32,168,186.91,167.16,187.48Zm4.87-3.66-.64-.77c.77-.64,1.51-1.31,2.22-2l.7.72C173.58,182.47,172.82,183.16,172,183.82Zm4.4-4.26-.74-.66c.66-.74,1.3-1.51,1.91-2.3l.79.61C177.77,178,177.11,178.81,176.43,179.56Zm3.75-4.84-.84-.55a22.51,22.51,0,0,0,1.45-2.57l.91.43A22.33,22.33,0,0,1,180.18,174.72Zm2.66-5.57-1-.3a22.72,22.72,0,0,0,.72-2.87l1,.18A22.52,22.52,0,0,1,182.84,169.15Zm1.11-6.06-1-.06c0-.53.05-1.08.05-1.63s0-.9,0-1.34l1-.05c0,.46,0,.92,0,1.39S184,162.54,184,163.09Zm-1.3-6a21.11,21.11,0,0,0-.7-2.87l1-.31a22,22,0,0,1,.73,3Zm-53.35-.85-.82-.58c.57-.8,1.18-1.62,1.82-2.45l.79.61C130.46,154.67,129.86,155.48,129.3,156.27Zm51.52-4.74a23.91,23.91,0,0,0-1.51-2.56l.83-.56a24.14,24.14,0,0,1,1.57,2.66Zm-47.85,0-.76-.65c.66-.77,1.36-1.53,2.07-2.26l.71.71C134.3,150,133.62,150.76,133,151.51Zm4.19-4.26-.66-.75c.57-.5,1.15-1,1.75-1.46l.62-.48.61.8-.61.46C138.29,146.29,137.72,146.76,137.16,147.25Zm40.33-.6a20.2,20.2,0,0,0-2.1-2l.63-.78a22.47,22.47,0,0,1,2.21,2.15Zm-35.56-3-.53-.85c.85-.54,1.75-1.05,2.66-1.52l.46.88C143.63,142.64,142.76,143.13,141.93,143.66Zm31-.82a22.32,22.32,0,0,0-2.6-1.41l.42-.91a24.45,24.45,0,0,1,2.72,1.48Zm-25.76-1.94-.39-.92.26-.11a25.11,25.11,0,0,1,2.65-.93l.27,1a24.67,24.67,0,0,0-2.54.9Zm20.4-.55-.24-.07c-.86-.28-1.75-.51-2.64-.71l.22-1c.91.21,1.83.45,2.72.73l.25.08Zm-14.71-1.11-.17-1a27.25,27.25,0,0,1,3.06-.35l.06,1C154.85,139,153.86,139.08,152.91,139.24Zm8.9-.18c-1-.12-2-.2-3-.23l0-1c1,0,2,.11,3.06.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '155.125px 186.41px 0px',
          }}
          id="elw4w3xonelm"
          className="animable"
        />
        <path
          d="M126.5,160.5l-1.67-1.15.57-.83.8.56c.18-.28.35-.56.53-.83l.84.54c-.27.42-.54.84-.79,1.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '126.2px 159.375px 0px',
          }}
          id="elmwf2tw12f3f"
          className="animable"
        />
        <path
          d="M122.51,157.75l-2.31-1.6.56-.83,2.32,1.6Zm-4.63-3.2-2.32-1.6.56-.82,2.32,1.59Zm-4.64-3.2-2.32-1.6.57-.82,2.32,1.6Zm-4.64-3.2-2.32-1.6.57-.82,2.32,1.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '114.68px 151.74px 0px',
          }}
          id="elwsve42mc81m"
          className="animable"
        />
        <path
          d="M104,145l-1.57-1.08.16-.37.6-1.39.91.41-.43,1,.9.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '103.5px 143.58px 0px',
          }}
          id="eljjfo73dxvm"
          className="animable"
        />
        <path
          d="M157,235l-1-.17a21.89,21.89,0,0,1,.72-3l1,.31A21,21,0,0,0,157,235Zm1.8-5.58-.89-.45c.19-.39.4-.77.62-1.13.31-.52.63-1,1-1.51l.83.56c-.32.48-.63,1-.93,1.46S159,229,158.79,229.39Zm3.31-4.9-.77-.64c.65-.78,1.34-1.54,2.07-2.26l.71.71C163.4,223,162.73,223.74,162.1,224.49Zm4.21-4.19-.64-.77.21-.17c.71-.58,1.44-1.15,2.18-1.71l.6.81c-.73.54-1.45,1.1-2.15,1.67Zm4.8-3.57-.56-.83c.83-.56,1.69-1.11,2.56-1.64l.52.85C172.77,215.64,171.92,216.18,171.11,216.73Zm4.87-3v-.5l-.35-.36.11-.08,2.64-1.47.49.87q-1.29.74-2.58,1.44l-.1.09Zm5.51-3-.49-.87,2.6-1.51.51.86Zm5.22-3.06-.52-.86.27-.16c.76-.47,1.52-1,2.26-1.45l.55.84c-.75.49-1.51,1-2.29,1.47Zm5.07-3.33-.57-.82c.83-.58,1.65-1.16,2.44-1.75l.59.8Q193,203.38,191.78,204.26Zm4.87-3.62-.62-.78c.65-.52,1.28-1,1.9-1.56l.41-.35.65.76-.42.36C198,199.6,197.31,200.12,196.65,200.64Zm4.6-4-.7-.72c.71-.69,1.41-1.41,2.09-2.14l.73.68C202.69,195.22,202,196,201.25,196.66Zm4.11-4.49-.77-.63c.62-.77,1.23-1.57,1.81-2.38l.81.58C206.62,190.57,206,191.38,205.36,192.17Zm3.54-5-.85-.52c.51-.84,1-1.72,1.46-2.6l.89.46C209.93,185.44,209.43,186.34,208.9,187.2Zm2.8-5.43-.92-.39c.39-.9.75-1.84,1.07-2.78l1,.33C212.46,179.89,212.09,180.85,211.7,181.77Zm2-5.76-1-.26c.25-.94.48-1.91.67-2.9l1,.19C214.2,174.05,214,175.05,213.71,176Zm1.18-6-1-.13c.13-1,.23-2,.31-3l1,.08C215.12,168,215,169.05,214.89,170Zm.47-6.07-1,0c0-.65,0-1.32,0-2,0-.33,0-.66,0-1l1,0c0,.34,0,.67,0,1C215.39,162.62,215.38,163.29,215.36,164Zm-1.08-6c-.06-1-.13-2-.23-3l1-.1c.1,1,.18,2,.24,3Zm-.6-6c-.15-1-.33-2-.53-2.94l1-.2c.2,1,.38,2,.54,3Zm-1.22-5.85c-.26-1-.55-1.92-.87-2.85l.95-.33c.32,1,.62,1.94.89,2.92Zm-1.92-5.65c-.33-.79-.69-1.58-1.07-2.34l-.18-.36.9-.45.18.37c.38.78.75,1.58,1.09,2.4Zm-105.17-.65-.89-.46c.47-.91,1-1.81,1.48-2.67l.86.51C106.32,138.06,105.83,138.94,105.37,139.83Zm102.51-4.69c-.5-.87-1-1.73-1.55-2.55l.83-.55c.55.84,1.08,1.72,1.59,2.6Zm-99.46-.45-.83-.56c.57-.85,1.16-1.68,1.78-2.48l.79.61C109.56,133,109,133.86,108.42,134.69Zm96.21-4.56c-.6-.8-1.22-1.59-1.85-2.35l.77-.64c.64.77,1.28,1.58,1.88,2.4Zm-92.58-.19-.76-.65.6-.69c.48-.53,1-1,1.45-1.56l.72.69c-.48.5-1,1-1.42,1.54Zm4.14-4.31-.68-.73c.74-.69,1.51-1.37,2.28-2l.64.77C117.67,124.29,116.92,125,116.19,125.63Zm84.6-.07c-.69-.72-1.4-1.42-2.13-2.09l.67-.73c.75.68,1.48,1.4,2.18,2.13Zm-80-3.77-.61-.8c.81-.61,1.65-1.2,2.49-1.76l.55.83C122.39,120.61,121.57,121.19,120.78,121.79Zm75.61-.25c-.78-.63-1.58-1.23-2.39-1.8l.58-.82c.82.58,1.64,1.2,2.43,1.83Zm-70.65-3.09-.51-.85c.86-.52,1.75-1,2.65-1.5l.47.88C127.47,117.45,126.59,117.94,125.74,118.45Zm65.77-.36c-.84-.53-1.71-1-2.58-1.51l.48-.87c.88.48,1.77,1,2.63,1.53ZM131,115.64l-.42-.9c.91-.43,1.85-.84,2.78-1.22l.38.92C132.85,114.82,131.92,115.22,131,115.64Zm55.24-.4c-.9-.42-1.82-.82-2.74-1.18l.37-.93c.94.37,1.88.78,2.8,1.2Zm-49.7-1.87-.33-.94c1-.34,1.92-.66,2.89-1l.28,1C138.45,112.73,137.5,113,136.56,113.37Zm44.15-.34-1.65-.52-1.22-.35.27-1,1.24.35,1.68.53Zm-38.42-1.39-.24-1c1-.25,2-.47,3-.68l.2,1C144.23,111.17,143.25,111.4,142.29,111.64Zm32.65-.22c-1-.23-1.95-.44-2.93-.62l.19-1q1.49.28,3,.63Zm-26.78-1-.16-1c1-.16,2-.3,3-.41l.12,1C150.13,110.14,149.14,110.28,148.16,110.44Zm20.89-.14c-1-.14-2-.26-3-.37l.1-1c1,.1,2,.23,3,.37Zm-14.94-.55-.07-1c1-.07,2-.12,3-.15l0,1C156.1,109.64,155.1,109.68,154.11,109.75Zm9,0c-1-.06-2-.1-3-.11v-1c1,0,2,0,3,.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '159.929px 171.79px 0px',
          }}
          id="elmk273gbhbnp"
          className="animable"
        />
        <path
          d="M156.63,240h-2v-1h1c0-.35,0-.69,0-1l1,.05c0,.48,0,1,0,1.48Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '155.63px 239px 0px',
          }}
          id="el8t6jfvsp9e"
          className="animable"
        />
        <path
          d="M151.69,240h-2.95v-1h2.95Zm-5.9,0h-2.94v-1h2.94Zm-5.89,0H137v-1h2.94ZM134,240h-2.94v-1H134Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '141.375px 239.5px 0px',
          }}
          id="el7i17a3brqrs"
          className="animable"
        />
        <polygon
          points="128.66 302.48 126.66 302.48 126.66 300.48 127.66 300.48 127.66 301.48 128.66 301.48 128.66 302.48"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '127.66px 301.48px 0px',
          }}
          id="elzlm364w1ass"
          className="animable"
        />
        <path
          d="M127.66,297.38h-1v-3.09h1Zm0-6.18h-1v-3.1h1Zm0-6.19h-1v-3.09h1Zm0-6.18h-1v-3.1h1Zm0-6.19h-1v-3.09h1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '127.16px 283.465px 0px',
          }}
          id="elxvalzbpswwa"
          className="animable"
        />
        <polygon
          points="127.66 266.45 126.66 266.45 126.66 264.45 128.66 264.45 128.66 265.45 127.66 265.45 127.66 266.45"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '127.66px 265.45px 0px',
          }}
          id="elxv7vwuxi5r9"
          className="animable"
        />
        <path
          d="M152.46,265.45h-3v-1h3Zm-6,0h-3v-1h3Zm-5.95,0h-3v-1h3Zm-5.95,0h-3v-1h3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '142.01px 264.95px 0px',
          }}
          id="elikrx89li7fg"
          className="animable"
        />
        <polygon
          points="157.44 266.45 156.44 266.45 156.44 265.45 155.44 265.45 155.44 264.45 157.44 264.45 157.44 266.45"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '156.44px 265.45px 0px',
          }}
          id="elv2yjxgqvk4s"
          className="animable"
        />
        <path
          d="M157.44,297.38h-1v-3.09h1Zm0-6.18h-1v-3.1h1Zm0-6.19h-1v-3.09h1Zm0-6.18h-1v-3.1h1Zm0-6.19h-1v-3.09h1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '156.94px 283.465px 0px',
          }}
          id="elj9w3b5vgtwd"
          className="animable"
        />
        <polygon
          points="157.44 302.48 155.44 302.48 155.44 301.48 156.44 301.48 156.44 300.48 157.44 300.48 157.44 302.48"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '156.44px 301.48px 0px',
          }}
          id="eladw692eft6s"
          className="animable"
        />
        <path
          d="M152.46,302.48h-3v-1h3Zm-6,0h-3v-1h3Zm-5.95,0h-3v-1h3Zm-5.95,0h-3v-1h3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '142.01px 301.98px 0px',
          }}
          id="elwhrcc4rvr49"
          className="animable"
        />
      </g>
      <g
        id="freepik--Gears--inject-12"
        style={{ transformOrigin: '333.885px 215.04px 0px' }}
        className="animable animator-hidden"
      >
        <path
          d="M417.7,296.32a17,17,0,1,0,17-17.05A17,17,0,0,0,417.7,296.32Zm9.08,0a8,8,0,1,1,8,7.95A8,8,0,0,1,426.78,296.32Z"
          style={{ fill: '#F53B57', transformOrigin: '434.7px 296.27px 0px' }}
          id="ely691t0ywdg8"
          className="animable"
        />
        <polygon
          points="431.46 279.98 438.01 279.98 437.65 275.34 431.82 275.34 431.46 279.98"
          style={{ fill: '#F53B57', transformOrigin: '434.735px 277.66px 0px' }}
          id="elr6syb86pk9f"
          className="animable"
        />
        <polygon
          points="443.94 282.19 448.57 286.82 451.59 283.29 447.47 279.17 443.94 282.19"
          style={{
            fill: '#F53B57',
            transformOrigin: '447.765px 282.995px 0px',
          }}
          id="el8g8opernus3"
          className="animable"
        />
        <polygon
          points="451.19 292.57 451.19 299.12 455.83 298.76 455.83 292.93 451.19 292.57"
          style={{ fill: '#F53B57', transformOrigin: '453.51px 295.845px 0px' }}
          id="elk6emukad5lb"
          className="animable"
        />
        <polygon
          points="448.99 305.04 444.35 309.68 447.89 312.7 452.01 308.58 448.99 305.04"
          style={{ fill: '#F53B57', transformOrigin: '448.18px 308.87px 0px' }}
          id="el9i6dhh8foe"
          className="animable"
        />
        <polygon
          points="438.6 312.3 432.05 312.3 432.41 316.94 438.24 316.94 438.6 312.3"
          style={{ fill: '#F53B57', transformOrigin: '435.325px 314.62px 0px' }}
          id="elw8zaoa2lvq"
          className="animable"
        />
        <polygon
          points="426.13 310.1 421.5 305.46 418.47 309 422.59 313.12 426.13 310.1"
          style={{ fill: '#F53B57', transformOrigin: '422.3px 309.29px 0px' }}
          id="elxmnskufz0uq"
          className="animable"
        />
        <polygon
          points="418.87 299.71 418.87 293.16 414.23 293.52 414.23 299.35 418.87 299.71"
          style={{ fill: '#F53B57', transformOrigin: '416.55px 296.435px 0px' }}
          id="elpycy9myzbtj"
          className="animable"
        />
        <polygon
          points="421.08 287.24 425.71 282.61 422.18 279.58 418.06 283.7 421.08 287.24"
          style={{ fill: '#F53B57', transformOrigin: '421.885px 283.41px 0px' }}
          id="el655j5dpw5z7"
          className="animable"
        />
        <path
          d="M438.58,292.47l-5.25-1.41-3.85,3.85,1.41,5.25,5.25,1.41,3.85-3.84ZM434.74,298a1.73,1.73,0,1,1,1.72-1.72A1.72,1.72,0,0,1,434.74,298Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '434.735px 296.315px 0px',
          }}
          id="elrhxnlhxzqro"
          className="animable"
        />
        <path
          d="M242.28,94.63a23.42,23.42,0,1,0,23.41-23.42A23.42,23.42,0,0,0,242.28,94.63Zm12.48,0a10.94,10.94,0,1,1,10.93,10.93A10.93,10.93,0,0,1,254.76,94.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '265.7px 94.6303px 0px',
          }}
          id="elpifv5ryw8mr"
          className="animable"
        />
        <polygon
          points="261.19 72.18 270.2 72.18 269.7 65.81 261.69 65.81 261.19 72.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '265.695px 68.995px 0px',
          }}
          id="elnnry1mrrxnb"
          className="animable"
        />
        <polygon
          points="278.33 75.22 284.7 81.58 288.86 76.72 283.19 71.06 278.33 75.22"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '283.595px 76.32px 0px',
          }}
          id="el78wbac688nf"
          className="animable"
        />
        <polygon
          points="288.31 89.48 288.31 98.49 294.68 97.99 294.68 89.98 288.31 89.48"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '291.495px 93.985px 0px',
          }}
          id="elg9a9cosho0e"
          className="animable"
        />
        <polygon
          points="285.27 106.62 278.91 112.99 283.77 117.14 289.43 111.48 285.27 106.62"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '284.17px 111.88px 0px',
          }}
          id="eldgj255zqkcc"
          className="animable"
        />
        <polygon
          points="271.01 116.6 262 116.6 262.5 122.97 270.51 122.97 271.01 116.6"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '266.505px 119.785px 0px',
          }}
          id="eljmyw304rypf"
          className="animable"
        />
        <polygon
          points="253.87 113.56 247.5 107.19 243.34 112.05 249.01 117.72 253.87 113.56"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '248.605px 112.455px 0px',
          }}
          id="elmsnbbu4v"
          className="animable"
        />
        <polygon
          points="243.89 99.3 243.89 90.29 237.52 90.79 237.52 98.8 243.89 99.3"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '240.705px 94.795px 0px',
          }}
          id="elen2h5fppw7v"
          className="animable"
        />
        <polygon
          points="246.93 82.16 253.29 75.79 248.44 71.63 242.77 77.3 246.93 82.16"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '248.03px 76.895px 0px',
          }}
          id="elmrpl3kiy7pn"
          className="animable"
        />
        <path
          d="M271,89.34l-7.22-1.93-5.29,5.29,1.94,7.21,7.22,1.94,5.29-5.29ZM265.69,97a2.37,2.37,0,1,1,2.37-2.37A2.37,2.37,0,0,1,265.69,97Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '265.715px 94.63px 0px',
          }}
          id="elvphivrg2awh"
          className="animable"
        />
        <path
          d="M409.33,349.39a17,17,0,1,0,16.94-16.95A17,17,0,0,0,409.33,349.39Zm3.61,0a13.34,13.34,0,1,1,13.33,13.34A13.34,13.34,0,0,1,412.94,349.39Zm-3.61,0a17,17,0,1,0,16.94-16.95A17,17,0,0,0,409.33,349.39Zm3.61,0a13.34,13.34,0,1,1,13.33,13.34A13.34,13.34,0,0,1,412.94,349.39Zm-15.23,0a28.57,28.57,0,1,0,28.56-28.58A28.57,28.57,0,0,0,397.71,349.39Zm10,0A18.58,18.58,0,1,1,426.27,368,18.61,18.61,0,0,1,407.7,349.39Zm1.63,0a17,17,0,1,0,16.94-16.95A17,17,0,0,0,409.33,349.39Zm3.61,0a13.34,13.34,0,1,1,13.33,13.34A13.34,13.34,0,0,1,412.94,349.39Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '426.28px 349.38px 0px',
          }}
          id="elqdx1u57x2w"
          className="animable"
        />
        <polygon
          points="422.92 321.33 429.47 321.33 428.81 314.8 423.57 314.8 422.92 321.33"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '426.195px 318.065px 0px',
          }}
          id="elnz3cnrydpeg"
          className="animable"
        />
        <polygon
          points="437.4 323.41 443.07 326.68 445.77 320.7 441.23 318.08 437.4 323.41"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '441.585px 322.38px 0px',
          }}
          id="el2wdn48tdeno"
          className="animable"
        />
        <polygon
          points="448.9 332.45 452.17 338.12 457.5 334.29 454.88 329.75 448.9 332.45"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '453.2px 333.935px 0px',
          }}
          id="el6kvsggydd6g"
          className="animable"
        />
        <polygon
          points="454.34 346.03 454.34 352.57 460.87 351.92 460.87 346.68 454.34 346.03"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '457.605px 349.3px 0px',
          }}
          id="elvt7hcs8h22"
          className="animable"
        />
        <polygon
          points="452.25 360.51 448.98 366.18 454.96 368.88 457.58 364.34 452.25 360.51"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '453.28px 364.695px 0px',
          }}
          id="elq12bx6mmulr"
          className="animable"
        />
        <polygon
          points="443.21 372.01 437.55 375.28 441.38 380.61 445.91 377.99 443.21 372.01"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '441.73px 376.31px 0px',
          }}
          id="elezwk63mjqlp"
          className="animable"
        />
        <polygon
          points="429.63 377.44 423.09 377.44 423.74 383.98 428.98 383.98 429.63 377.44"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '426.36px 380.71px 0px',
          }}
          id="elmy12oevd7fi"
          className="animable"
        />
        <polygon
          points="415.16 375.36 409.49 372.09 406.79 378.07 411.33 380.69 415.16 375.36"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '410.975px 376.39px 0px',
          }}
          id="elcay9ksr5o09"
          className="animable"
        />
        <polygon
          points="403.66 366.32 400.39 360.66 395.06 364.49 397.68 369.02 403.66 366.32"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '399.36px 364.84px 0px',
          }}
          id="elwed5plox6gk"
          className="animable"
        />
        <polygon
          points="398.22 352.74 398.22 346.2 391.69 346.85 391.69 352.09 398.22 352.74"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '394.955px 349.47px 0px',
          }}
          id="el1ee9idgxcpy"
          className="animable"
        />
        <polygon
          points="400.3 338.27 403.57 332.6 397.59 329.9 394.97 334.44 400.3 338.27"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '399.27px 334.085px 0px',
          }}
          id="el5j7kebz03mw"
          className="animable"
        />
        <polygon
          points="409.34 326.77 415.01 323.5 411.18 318.17 406.64 320.79 409.34 326.77"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '410.825px 322.47px 0px',
          }}
          id="elbjxxoxqvixm"
          className="animable"
        />
        <path
          d="M226.08,74.19a7.78,7.78,0,1,0-7-8.46A7.78,7.78,0,0,0,226.08,74.19ZM220,65.82a6.83,6.83,0,1,1,6.17,7.42A6.83,6.83,0,0,1,220,65.82Zm6.08,8.37a7.78,7.78,0,1,0-7-8.46A7.78,7.78,0,0,0,226.08,74.19ZM220,65.82a6.83,6.83,0,1,1,6.17,7.42A6.83,6.83,0,0,1,220,65.82Zm6.08,8.37a7.78,7.78,0,1,0-7-8.46A7.78,7.78,0,0,0,226.08,74.19ZM220,65.82a6.83,6.83,0,1,1,6.17,7.42A6.83,6.83,0,0,1,220,65.82Zm5.28,17a16.39,16.39,0,1,0-14.79-17.84A16.4,16.4,0,0,0,225.28,82.77Zm-7.42-17.15A9,9,0,1,1,226,75.39,9,9,0,0,1,217.86,65.62Zm1.2.11a7.78,7.78,0,1,0,8.46-7A7.78,7.78,0,0,0,219.06,65.73Zm.94.09a6.83,6.83,0,1,1,6.17,7.42A6.83,6.83,0,0,1,220,65.82Zm6.08,8.37a7.78,7.78,0,1,0-7-8.46A7.78,7.78,0,0,0,226.08,74.19ZM220,65.82a6.83,6.83,0,1,1,6.17,7.42A6.83,6.83,0,0,1,220,65.82Zm6.08,8.37a7.78,7.78,0,1,0-7-8.46A7.78,7.78,0,0,0,226.08,74.19ZM220,65.82a6.83,6.83,0,1,1,6.17,7.42A6.83,6.83,0,0,1,220,65.82Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '226.812px 66.5013px 0px',
          }}
          id="el8n6o63wcpg"
          className="animable"
        />
        <polygon
          points="225.12 50.51 231.39 51.09 231.46 46.62 225.88 46.1 225.12 50.51"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '228.29px 48.595px 0px',
          }}
          id="elfdoroafi43r"
          className="animable"
        />
        <polygon
          points="236.87 53.74 240.89 58.59 244.1 55.47 240.52 51.16 236.87 53.74"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '240.485px 54.875px 0px',
          }}
          id="elmysgfrind5k"
          className="animable"
        />
        <polygon
          points="242.89 64.32 242.31 70.6 246.78 70.66 247.3 65.08 242.89 64.32"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '244.805px 67.49px 0px',
          }}
          id="elvv6j3ec0z6q"
          className="animable"
        />
        <polygon
          points="239.67 76.07 234.82 80.1 237.94 83.31 242.25 79.73 239.67 76.07"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '238.535px 79.69px 0px',
          }}
          id="elqfsex0n18ia"
          className="animable"
        />
        <polygon
          points="229.08 82.1 222.81 81.52 222.74 85.99 228.32 86.51 229.08 82.1"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '225.91px 84.015px 0px',
          }}
          id="el5zpjc8mkulo"
          className="animable"
        />
        <polygon
          points="217.34 78.87 213.31 74.02 210.1 77.14 213.68 81.45 217.34 78.87"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '213.72px 77.735px 0px',
          }}
          id="elq2kq5pqf878"
          className="animable"
        />
        <polygon
          points="211.31 68.29 211.89 62.01 207.42 61.95 206.9 67.53 211.31 68.29"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '209.395px 65.12px 0px',
          }}
          id="eledewclb53m5"
          className="animable"
        />
        <polygon
          points="214.53 56.54 219.38 52.51 216.26 49.3 211.95 52.88 214.53 56.54"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '215.665px 52.92px 0px',
          }}
          id="ellgobxpk0xze"
          className="animable"
        />
        <path
          d="M350.6,339a19.69,19.69,0,1,0,20.19-19.17A19.69,19.69,0,0,0,350.6,339Zm10.49.27a9.19,9.19,0,1,1,8.94,9.44A9.19,9.19,0,0,1,361.09,339.27Z"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '370.284px 339.514px 0px',
          }}
          id="elc7qbwe1tacw"
          className="animable"
        />
        <polygon
          points="366.99 320.55 374.56 320.75 374.28 315.38 367.55 315.2 366.99 320.55"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '370.775px 317.975px 0px',
          }}
          id="el7khfvzfvlb9"
          className="animable"
        />
        <polygon
          points="381.33 323.48 386.54 328.97 390.14 324.98 385.5 320.1 381.33 323.48"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '385.735px 324.535px 0px',
          }}
          id="el9wj2jtlpcle"
          className="animable"
        />
        <polygon
          points="389.4 335.69 389.2 343.26 394.56 342.98 394.74 336.25 389.4 335.69"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '391.97px 339.475px 0px',
          }}
          id="elnrq27qliep"
          className="animable"
        />
        <polygon
          points="386.47 350.03 380.97 355.24 384.96 358.84 389.85 354.21 386.47 350.03"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '385.41px 354.435px 0px',
          }}
          id="eldskmwqbbssp"
          className="animable"
        />
        <polygon
          points="374.25 358.1 366.69 357.9 366.96 363.26 373.69 363.44 374.25 358.1"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '370.47px 360.67px 0px',
          }}
          id="elm6bx60y1bes"
          className="animable"
        />
        <polygon
          points="359.92 355.17 354.71 349.67 351.11 353.67 355.74 358.55 359.92 355.17"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '355.515px 354.11px 0px',
          }}
          id="elho2zep9qulv"
          className="animable"
        />
        <polygon
          points="351.85 342.96 352.05 335.39 346.68 335.67 346.5 342.4 351.85 342.96"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '349.275px 339.175px 0px',
          }}
          id="elqj3hl9ywuzo"
          className="animable"
        />
        <polygon
          points="354.78 328.62 360.27 323.41 356.28 319.81 351.4 324.44 354.78 328.62"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '355.835px 324.215px 0px',
          }}
          id="el51x06qfalar"
          className="animable"
        />
        <path
          d="M375.51,334.69l-6.46-1.91-4.88,4.63,1.57,6.54,6.45,1.92,4.89-4.63Zm-4.94,6.77a2.14,2.14,0,1,1,2.19-2.08A2.14,2.14,0,0,1,370.57,341.46Z"
          style={{
            fill: 'rgb(199, 199, 199)',
            transformOrigin: '370.625px 339.325px 0px',
          }}
          id="elwktkx1xfqq"
          className="animable"
        />
      </g>
      <g
        id="freepik--Brushes--inject-12"
        style={{ transformOrigin: '633.059px 389.422px 0px' }}
        className="animable animator-hidden"
      >
        <path
          d="M620.49,358.09s4,13.48,8.84,27.25,9.07,45.4,8.18,46.22-11.56-29.93-14.63-44-5.28-28.47-5.28-28.47Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '627.615px 394.833px 0px',
          }}
          id="el5ciabwmw2kj"
          className="animable"
        />
        <polygon
          points="620.56 357.75 623.76 366.91 618.66 368.15 617.13 358.71 620.56 357.75"
          style={{
            fill: 'rgb(219, 219, 219)',
            transformOrigin: '620.445px 362.95px 0px',
          }}
          id="el8310ys8dqz"
          className="animable"
        />
        <path
          d="M620.56,357.75a7.61,7.61,0,0,0-1.21-6.88c-2.23-3.18-1.58-5.66-1.58-5.66s-5.74,7.36-.64,13.51Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '617.962px 351.965px 0px',
          }}
          id="elro1q3jzwgk"
          className="animable"
        />
        <path
          d="M617.82,344.85c.29.46-.3,2.77.77,4.58s-4.19,4.51-3.76,1.79C615.32,348.14,617.29,344,617.82,344.85Z"
          style={{ fill: '#F53B57', transformOrigin: '616.77px 348.556px 0px' }}
          id="el8bvbs5bsqfr"
          className="animable"
        />
        <path
          d="M645.64,366s-3.91,10.91-8.45,22-9.42,36.95-8.72,37.66,10.8-24.12,13.93-35.54S648,367,648,367Z"
          style={{
            fill: 'rgb(166, 166, 166)',
            transformOrigin: '638.201px 395.837px 0px',
          }}
          id="elbi4pqr1tae"
          className="animable"
        />
        <polygon
          points="645.6 365.7 642.57 373.09 646.71 374.33 648.38 366.64 645.6 365.7"
          style={{
            fill: 'rgb(219, 219, 219)',
            transformOrigin: '645.475px 370.015px 0px',
          }}
          id="elcpnh5dxolb"
          className="animable"
        />
        <path
          d="M645.6,365.7c.44-6.08,5.27-11,5.27-11s2,7.14-2.49,12Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '648.457px 360.7px 0px',
          }}
          id="el0o7nlvcihyzm"
          className="animable"
        />
        <path
          d="M633.62,351.67s1.54,11.49,3.66,23.31,1.5,38.1.67,38.65-5.52-25.84-6.21-37.67-.61-23.83-.61-23.83Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '634.924px 382.654px 0px',
          }}
          id="elq9zbzcsppg"
          className="animable"
        />
        <polygon
          points="633.72 351.4 635.14 359.27 630.83 359.62 630.8 351.74 633.72 351.4"
          style={{
            fill: 'rgb(219, 219, 219)',
            transformOrigin: '632.97px 355.51px 0px',
          }}
          id="elp3h77xfw3mo"
          className="animable"
        />
        <path
          d="M630.8,351.74s2.76-.27,2.92-.33a66.84,66.84,0,0,0,2-8.2c-.17-.22-9.29,1.05-9.24,1.91S630.8,351.74,630.8,351.74Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '631.1px 347.462px 0px',
          }}
          id="el0valv05jh6xk"
          className="animable"
        />
        <rect
          x="615.57"
          y="395.18"
          width="32.15"
          height="40.48"
          rx="4.38"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '631.645px 415.42px 0px',
          }}
          id="elfj29h1ht23n"
          className="animable"
        />
        <rect
          x="619.63"
          y="388.79"
          width="24.04"
          height="6.39"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '631.65px 391.985px 0px',
          }}
          id="elzvs7xp3crx"
          className="animable"
        />
        <path
          d="M621.1,395c5.59-.27,19.27-.28,21.11,0,0,0,0,.08,0,.08a146.94,146.94,0,0,1-21.11,0A.06.06,0,0,1,621.1,395Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '631.647px 395.127px 0px',
          }}
          id="el78q3j1xzbk2"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-2--inject-12"
        style={{ transformOrigin: '522.65px 318.383px 0px' }}
        className="animable"
      >
        <path
          d="M398.54,442.43c.24-2.14,24.77-55,27-56.42.83-.56,8.74,2.57,18.19,6.62l.3.13c1.95.83,37.91,10.49,37.91,10.49L466,437.85,428.56,427l-.57-.28s-18.44,16-21,17.34S398.3,444.56,398.54,442.43Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '440.237px 415.326px 0px',
          }}
          id="elpany6mnh6j"
          className="animable"
        />
        <path
          d="M450.85,394.77l-16.4,34-5.88-1.7-.58-.28s-18.44,16-21,17.34-8.65.46-8.41-1.67,24.77-55,27-56.42c.83-.56,8.74,2.57,18.2,6.62l.29.13C444.49,393,447.15,393.74,450.85,394.77Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '424.712px 415.371px 0px',
          }}
          id="elmfim9evhgol"
          className="animable"
        />
        <path
          d="M398.33,442.69c.24-2.15,24.82-55.62,27.05-57.07.84-.55,8.84,2.57,18.39,6.63L428,426.77S409.45,443,406.84,444.35,398.1,444.85,398.33,442.69Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '421.047px 415.278px 0px',
          }}
          id="elpvtz5gf2jn"
          className="animable"
        />
        <path
          d="M400.82,442.91c4.35-8.86,21-45,24.64-54.11,0-.07,0-.09-.06,0-4.49,8.69-20.87,45-24.72,54.06C400.6,443,400.73,443.1,400.82,442.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '413.058px 415.877px 0px',
          }}
          id="elmo2ciir8dr"
          className="animable"
        />
        <path
          d="M410.34,441.8a7.92,7.92,0,0,0,.28-6.37,7.71,7.71,0,0,0-3.87-4.21c-.05,0-.1.08,0,.11a9.17,9.17,0,0,1,3.52,10.42C410.2,441.82,410.31,441.87,410.34,441.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '408.925px 436.527px 0px',
          }}
          id="el8gvyz9u5d0c"
          className="animable"
        />
        <path
          d="M425.53,429.83c1.7-3.56,2.34-8.3.44-11.88-.08-.14-.27,0-.27.1a54.67,54.67,0,0,1-.64,11.64A.25.25,0,0,0,425.53,429.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '426.094px 423.927px 0px',
          }}
          id="eltzyj8z68ql"
          className="animable"
        />
        <path
          d="M423.18,432.11c1.7-3.57,2.34-8.31.43-11.89-.07-.14-.27,0-.26.1a54.67,54.67,0,0,1-.64,11.64A.25.25,0,0,0,423.18,432.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '423.743px 426.204px 0px',
          }}
          id="el66r2qcbwx1w"
          className="animable"
        />
        <path
          d="M420.82,434.38c1.7-3.57,2.35-8.31.44-11.89-.07-.14-.27,0-.26.1a54.77,54.77,0,0,1-.65,11.65A.25.25,0,0,0,420.82,434.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '421.386px 428.472px 0px',
          }}
          id="ellzdwcv33lf"
          className="animable"
        />
        <path
          d="M418.47,436.65c1.7-3.56,2.35-8.3.44-11.88-.08-.14-.27,0-.27.1a54.71,54.71,0,0,1-.64,11.64A.25.25,0,0,0,418.47,436.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '419.036px 430.747px 0px',
          }}
          id="el0rp9wn544f6g"
          className="animable"
        />
        <path
          d="M432.92,395c1.84-4-4.42-6.89-6.26-2.86S431.08,399,432.92,395Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '429.79px 393.567px 0px',
          }}
          id="elhk28zot2wol"
          className="animable"
        />
        <path
          d="M433.32,438.11c2.34-1.12,1.92-4.09.87-5.93a20.74,20.74,0,0,0-7.67-7.47.11.11,0,0,0-.16.06.48.48,0,0,0-.58.51c.59,3.37.8,7,2.41,10.13C429.13,437.21,431.11,439.17,433.32,438.11Zm-5.6-7.91c-.33-1.65-.58-3.3-1-4.94,1.49,1.47,3,2.86,4.38,4.47a22.5,22.5,0,0,1,1.82,2.42c.83,1.33,2.21,6.23-1.86,4.79C428.85,436.15,428.11,432.17,427.72,430.2Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '430.405px 431.552px 0px',
          }}
          id="eledx9s4ib2qe"
          className="animable"
        />
        <path
          d="M429.29,415.18c-1.92,2.9-2.51,6.54-3.45,9.82a.49.49,0,0,0,.53.57c0,.07.07.12.15.08a20.62,20.62,0,0,0,8.4-6.65c1.23-1.72,2-4.62-.26-6S430.4,413.49,429.29,415.18Zm3-1.23c4.2-1,2.32,3.72,1.36,5a22.65,22.65,0,0,1-2.05,2.22,61.22,61.22,0,0,1-4.83,4c.56-1.58,1-3.21,1.48-4.81C428.87,418.39,430,414.51,432.32,414Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '430.969px 419.092px 0px',
          }}
          id="eld1j4qxnh2w"
          className="animable"
        />
        <path
          d="M524.12,290.39s-.67,20.72-3.77,30.93c0,0-3.39,1.78-4.41,2.42,0,0,25.75,61.64,24.28,85.36-.48,7.77-8.76,17.61-17.65,23.15-15.74,9.79-88.1,4.14-88.1,4.14l11.15-46.19s43.57,2.7,44.8.07c1.56-3.33-8.11-29.26-15.84-50.33-.78-2.12-8.55-10-7.64-24.18a73.6,73.6,0,0,1,6.68-25.37Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '487.375px 364.201px 0px',
          }}
          id="el17lrv1svv9f"
          className="animable"
        />
        <path
          d="M454.48,395.33c10.6-.19,19.23.71,29.83.71h7a11.58,11.58,0,0,0,2.76-.25,3.44,3.44,0,0,0,2.14-1.27c.7-1,.32-2.38.08-3.52-.53-2.49-1.14-5-1.79-7.43-2.67-10-6.16-19.79-9.44-29.61L480,338.79c-.41-1.23-.82-2.46-1.34-3.65A30,30,0,0,0,477,332a29.76,29.76,0,0,1-2.88-6.25c-2.87-9.42-.11-19.17,3.24-28.06.45-1.19.92-2.38,1.4-3.56,0-.08.17,0,.14,0-3.06,9.39-6.7,19.15-4.65,29.16A24.11,24.11,0,0,0,476.7,330c.59,1.08,1.23,2.12,1.8,3.2a26.54,26.54,0,0,1,1.48,3.42c1.79,5,3.38,10,5.07,15,3.35,10,6.87,19.92,9.66,30.06.69,2.53,1.34,5.07,1.91,7.63.42,1.88,1.36,4.45-.29,6-1.2,1.14-3.09,1.28-4.66,1.29-2.64,0-5.29,0-7.93,0-10.74,0-27.94-.93-29.27-1C454.23,395.7,454.24,395.34,454.48,395.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '475.782px 345.347px 0px',
          }}
          id="elr64th379we9"
          className="animable"
        />
        <path
          d="M442.63,434.24c1-5.39,2-10.82,3.23-16.18s2.49-10.74,3.88-16.07c.39-1.51.8-3,1.2-4.51.19-.72.38-1.43.59-2.14a22.47,22.47,0,0,1,.66-2.16.08.08,0,0,1,.14.05,29.46,29.46,0,0,1-.74,4.14c-.26,1.3-.51,2.6-.78,3.9q-.82,4-1.7,8c-1.17,5.35-2.5,10.66-3.86,16q-1.17,4.53-2.35,9C442.86,434.46,442.59,434.42,442.63,434.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '447.478px 413.774px 0px',
          }}
          id="eluc7awmccwu"
          className="animable"
        />
        <path
          d="M531.4,365.91l-54.54-19.75c-.76-2.1-1.53-4.18-2.28-6.22s-8.55-10-7.64-24.18a73.35,73.35,0,0,1,6.68-25.37h50.49s-.65,20.72-3.76,30.92c0,0-3.39,1.79-4.41,2.43C515.94,323.74,524.44,344.09,531.4,365.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '499.133px 328.15px 0px',
          }}
          id="elhnw39v7aqab"
          className="animable"
        />
        <path
          d="M614.31,444.91c-2.06.62-60.31-1.31-62.48-2.79-.83-.55-1-9.05-1-19.34,0-.1,0-.21,0-.32,0-2.12.91-37.65.91-37.65L592.52,386l-4.1,37.24,0,.64s22,10.71,24.18,12.59S616.37,444.3,614.31,444.91Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '583.048px 414.92px 0px',
          }}
          id="elmxk6bkf9bzq"
          className="animable"
        />
        <path
          d="M614.31,444.92c-2.06.61-60.31-1.32-62.47-2.8-.84-.56-1.06-9.06-1-19.33v-.33c0-.58,0-3.46.18-7.83l38.21,1.47-.79,7.18,0,.64s22,10.72,24.19,12.59S616.37,444.3,614.31,444.92Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '583.054px 429.833px 0px',
          }}
          id="el2fy2n77n819"
          className="animable"
        />
        <path
          d="M614.75,445.16c-2.08.62-60.89-1.34-63.09-2.83-.84-.56-1-9.14-1-19.52L588.57,424s22.19,10.82,24.42,12.72S616.83,444.54,614.75,445.16Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '583.187px 434.044px 0px',
          }}
          id="elk3hv9rocspb"
          className="animable"
        />
        <path
          d="M614,442.78c-9.85-.57-49.64-1.94-59.43-1.75-.07,0-.08.05,0,.06,9.76.78,49.55,1.83,59.42,1.85C614.19,443,614.19,442.8,614,442.78Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '584.328px 441.982px 0px',
          }}
          id="el0z4latszwdp"
          className="animable"
        />
        <path
          d="M609.28,434.44a7.89,7.89,0,0,0-6,2.21,7.68,7.68,0,0,0-2.38,5.19c0,.06.11.06.12,0a9.15,9.15,0,0,1,8.23-7.28C609.35,434.56,609.36,434.44,609.28,434.44Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '605.117px 438.154px 0px',
          }}
          id="eltfjtcjsqa3"
          className="animable"
        />
        <path
          d="M592.36,425.07c-3.94-.19-8.56,1.05-11.12,4.2-.1.12.07.26.19.21a54.22,54.22,0,0,1,11-3.92A.25.25,0,0,0,592.36,425.07Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '586.91px 427.271px 0px',
          }}
          id="el4jsxeigluff"
          className="animable"
        />
        <path
          d="M595.37,426.36c-4-.19-8.57,1.05-11.13,4.2-.1.12.08.26.2.2a54.58,54.58,0,0,1,11-3.91A.25.25,0,0,0,595.37,426.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '589.915px 428.558px 0px',
          }}
          id="el6nneqjfrzzj"
          className="animable"
        />
        <path
          d="M598.38,427.65c-4-.19-8.57,1.05-11.13,4.2-.1.12.08.26.2.2a54.36,54.36,0,0,1,11-3.91A.25.25,0,0,0,598.38,427.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '592.926px 429.848px 0px',
          }}
          id="eltzazgnd3sb"
          className="animable"
        />
        <path
          d="M601.38,428.94c-3.94-.19-8.56,1.05-11.12,4.2-.1.12.07.26.19.2a54.06,54.06,0,0,1,11-3.91A.25.25,0,0,0,601.38,428.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '595.93px 431.138px 0px',
          }}
          id="elg5xjyguvoi"
          className="animable"
        />
        <path
          d="M557.39,431.75c-4.43-.14-4.65,6.74-.21,6.88S561.82,431.88,557.39,431.75Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '557.285px 435.19px 0px',
          }}
          id="elkermcppfz37"
          className="animable"
        />
        <path
          d="M597,414.68c-1.94-1.72-4.51-.19-5.8,1.49a20.78,20.78,0,0,0-3.93,10,.11.11,0,0,0,.12.11.48.48,0,0,0,.7.34c2.88-1.85,6.18-3.47,8.4-6.14C597.77,418.89,598.82,416.31,597,414.68Zm-5.12,8.23c-1.39.94-2.82,1.81-4.18,2.81a60.81,60.81,0,0,1,2.42-5.78,22,22,0,0,1,1.53-2.61c.9-1.27,4.88-4.44,5.13-.14C596.9,419.57,593.52,421.78,591.86,422.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '592.623px 420.301px 0px',
          }}
          id="elgarofxvwla"
          className="animable"
        />
        <path
          d="M577.4,427.28c3.42.64,7-.22,10.39-.63a.48.48,0,0,0,.32-.71s.08-.1,0-.16a20.79,20.79,0,0,0-9.39-5.18c-2.06-.46-5,0-5.42,2.56S575.41,426.91,577.4,427.28ZM575.09,425c-2.55-3.48,2.54-3.58,4-3.18a23.65,23.65,0,0,1,2.85,1c1.93.82,3.71,1.9,5.55,2.9-1.68.1-3.34.34-5,.5C580.52,426.42,576.5,426.87,575.09,425Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '580.714px 423.976px 0px',
          }}
          id="elhoomhfm4fi9"
          className="animable"
        />
        <path
          d="M591.74,420.44H546.13s8.12-62.09,5.42-66.15c-1.19-1.77-60.4,4.16-77.72-14.6-15.84-17.16.28-49.3.28-49.3h48.6s1,13.78,3.6,19.28c1.13,2.36,55.42-1,63.92,14.51C601.58,344.91,591.74,420.44,591.74,420.44Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '531.28px 355.415px 0px',
          }}
          id="elb2aow7bl3di"
          className="animable"
        />
        <path
          d="M550.94,411.77c5.14-.15,10.3-.36,15.46-.35s10.33.11,15.49.31c1.46.06,5.76.27,6.46.32a16.37,16.37,0,0,1,2.1.18c.08,0,.06.12,0,.13-1.12.2-12.79.33-15.35.34-5.13,0-10.26-.14-15.39-.32l-8.75-.33C550.79,412,550.77,411.77,550.94,411.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '570.663px 412.06px 0px',
          }}
          id="elxtvf1lcktcd"
          className="animable"
        />
        <path
          d="M520.73,305.27q-.32-2.19-.57-4.38c-.4-3.33-.74-6.69-.84-10.05,0-.26.36-.24.39,0,.31,2.59.55,5.19.85,7.78s.51,5.18,1,7.72c.15.76.47,2,1.45,2.06,1.32,0,1.57-1.75,1.68-2.72a42.83,42.83,0,0,0,.13-7.25c-.14-2.76-.49-5.51-.79-8.25,0-.09.15-.11.17,0,1.13,5.33,2.22,10.92,1.28,16.37a3,3,0,0,1-1.77,2.57h-.05a.32.32,0,0,1,0,.09c0,.16,0,.31,0,.47a2.54,2.54,0,0,1,0,.39c0,.27,0,.54,0,.81a.2.2,0,0,1-.4,0,.17.17,0,0,1-.14-.13,4.2,4.2,0,0,1,0-1.58,1.93,1.93,0,0,1-1.62-.87A6.77,6.77,0,0,1,520.73,305.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '522.578px 300.592px 0px',
          }}
          id="el1znfga9necai"
          className="animable"
        />
        <path
          d="M525.56,309.21a78.35,78.35,0,0,0-10.46,8.61.14.14,0,0,0,.18.21c3.56-2.75,7.22-5.45,10.62-8.39A.27.27,0,0,0,525.56,309.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '520.535px 313.601px 0px',
          }}
          id="el9nqgj1fw254"
          className="animable"
        />
        <path
          d="M485.61,311.86a20.65,20.65,0,0,0,3.14-.24,25.22,25.22,0,0,0,2.72-.7c1.69-.49,3.74-1.08,5-2.41a18.16,18.16,0,0,0,2.82-4.86,19.88,19.88,0,0,0,1.65-5.79c0-.09.15-.09.14,0a30.21,30.21,0,0,1-1,6.13,19.66,19.66,0,0,1-1.15,2.9,8.09,8.09,0,0,1-7.11,5.16,17,17,0,0,1-6.19,0C485.44,312.07,485.48,311.86,485.61,311.86Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '493.29px 305.063px 0px',
          }}
          id="elbfzkeexn8vf"
          className="animable"
        />
        <path
          d="M556.47,351.36a2.68,2.68,0,0,0-2.24-2.12,21.6,21.6,0,0,0-3.94-.08c-3,0-6.08.06-9.12.07-12,0-24-.31-35.81-2.67a83.51,83.51,0,0,1-16.74-5.06c-4.57-2-9.14-4.68-12-8.89-3.27-4.83-3.53-11.16-3.42-16.82a64.74,64.74,0,0,1,2.93-18c.47-1.48,1-2.94,1.58-4.38,0-.09-.1-.17-.14-.07a62.73,62.73,0,0,0-4.75,17.37,59.88,59.88,0,0,0-.4,8.88,34.32,34.32,0,0,0,1.12,8.62c3.11,10.59,15,15,24.57,17.65,11.55,3.24,23.6,4.14,35.54,4.32,6,.09,12,0,18-.09,1.14,0,3-.33,3.71.87a6.53,6.53,0,0,1,.54,2.18c.13.85.22,1.7.29,2.55a72.94,72.94,0,0,1-.13,9.58q-.57,9.72-1.35,19.43c-.51,6.51-1.24,13-1.71,19.52-.12,1.59-.27,3.18-.42,4.78,0,.18.29.21.32,0,1.66-12.87,2.86-25.79,3.7-38.73.21-3.2.45-6.4.54-9.61A34.7,34.7,0,0,0,556.47,351.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '514.801px 351.22px 0px',
          }}
          id="elmw8ndc7etl"
          className="animable"
        />
        <path
          d="M527.26,353.74a100.15,100.15,0,0,1-12.11-.88c-3.78-.48-7.56-1-11.32-1.64-6.54-1.11-13.22-2.34-19.4-4.83a34,34,0,0,1-9.34-5.42c-.08-.06-.18,0-.11.11,4.67,4.54,10.59,7.2,16.82,8.9a137.34,137.34,0,0,0,21.78,3.82,117.93,117.93,0,0,0,13.69.4A.23.23,0,0,0,527.26,353.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '501.226px 347.598px 0px',
          }}
          id="el5g3jjehhkb2"
          className="animable"
        />
        <path
          d="M501.57,245.62c14.42,8.78,35.26,20.14,38.55,15.6,8.41-11.6,12.67-36.92,12.75-42.85,0-3.44-24.83-9-25.39-5.33-.64,4.26-1.66,25.73-3,26.81-1,.82-15.95-3.42-20.37-3.68C493.22,235.51,494.88,241.55,501.57,245.62Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '524.557px 237.044px 0px',
          }}
          id="elb1bahyvolrk"
          className="animable"
        />
        <path
          d="M526,218.93l28.56,4.12s-7.09,35.39-15.49,39.25c-4.9,2.26-26.42-7.72-37.37-15.56-11.94-8.54-4.17-12.26,4.17-10.79,6.64,1.16,17.75,3.75,18,3.26S526,218.93,526,218.93Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '525.066px 240.778px 0px',
          }}
          id="elmyqeosxg77t"
          className="animable"
        />
        <g id="elmx8kp9q8wbn">
          <path
            d="M528.53,236.76a8.82,8.82,0,0,0,.34,2.62,9.45,9.45,0,0,0,.34-2.63,9.58,9.58,0,0,0-.33-2.63A9.63,9.63,0,0,0,528.53,236.76ZM533,262l.65.14a8.26,8.26,0,0,0-.32-2.08A8.13,8.13,0,0,0,533,262Zm2.28-34.48a9.37,9.37,0,0,0-2.62.33,10.12,10.12,0,0,0,5.24,0A9.82,9.82,0,0,0,535.29,227.53ZM523.94,251.3a8.77,8.77,0,0,0-2.62.33,10.16,10.16,0,0,0,5.25,0A9.5,9.5,0,0,0,523.94,251.3Zm-24-11.41a9.57,9.57,0,0,0-2.09-1.62A10.31,10.31,0,0,0,501.5,242,9.31,9.31,0,0,0,499.9,239.89Zm49.71-10.68a9.67,9.67,0,0,0-2.1-1.63,9.42,9.42,0,0,0,1.61,2.11,9.86,9.86,0,0,0,2.09,1.63A9.1,9.1,0,0,0,549.61,229.21Zm-10.54,21.65a9.67,9.67,0,0,0-2.1-1.63,9.14,9.14,0,0,0,1.61,2.11,9.28,9.28,0,0,0,2.09,1.62A9.55,9.55,0,0,0,539.07,250.86Zm3.85-11.7a9.6,9.6,0,0,0-1.63,2.1,9.38,9.38,0,0,0,2.11-1.6,9.27,9.27,0,0,0,1.62-2.1A9,9,0,0,0,542.92,239.16Zm-29.35,3.19a10.15,10.15,0,0,0-1.62,2.09,10.16,10.16,0,0,0,3.74-3.7A9.41,9.41,0,0,0,513.57,242.35Z"
            style={{
              opacity: '0.1',
              transformOrigin: '524.55px 244.829px 0px',
            }}
            className="animable"
            id="eli0taujgfe3b"
          />
        </g>
        <path
          d="M539.36,227c-2.08-.31-4.15-.57-6.23-.84-1-.12-2-.26-3-.35s-2.18-.29-3.26-.32a.06.06,0,0,0,0,.12c1,.29,2.15.42,3.21.64s2,.36,3,.53c2.07.35,4.13.7,6.2,1,4.15.61,8.3,1.09,12.47,1.53.1,0,.13-.14,0-.15C547.61,228.34,543.5,227.61,539.36,227Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '539.324px 227.4px 0px',
          }}
          id="el5vyic6ae7rq"
          className="animable"
        />
        <g id="elmdkeko9nbj">
          <path
            d="M549.13,243.83c-2.73,8.48-6.27,16.72-10.08,18.47-4.9,2.26-26.42-7.72-37.36-15.55-6.21-4.44-7.09-7.57-5.35-9.37Z"
            style={{
              opacity: '0.1',
              transformOrigin: '522.342px 250.003px 0px',
            }}
            className="animable"
            id="ellwf6h8vsuki"
          />
        </g>
        <path
          d="M617.49,220.68s-30.36-1.54-61.74-4.52-99.83,4.41-101.07,6.72,68.78,8.83,99.82,8,62.38-3.61,62.38-3.61Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '536.077px 223.207px 0px',
          }}
          id="el586d2z2npde"
          className="animable"
        />
        <polygon
          points="618.16 220.36 597.29 218.34 597.4 229.73 617.97 228.08 618.16 220.36"
          style={{
            fill: 'rgb(219, 219, 219)',
            transformOrigin: '607.725px 224.035px 0px',
          }}
          id="elbdt1jsj0xt"
          className="animable"
        />
        <path
          d="M618.16,220.36c3.77-2.16,8.55-3.53,15.05-1,7.84,3,12.67.39,12.67.39s-12.34,15.89-27.91,8.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '631.925px 224.06px 0px',
          }}
          id="el77lh4npsznp"
          className="animable"
        />
        <path
          d="M646.63,219.44c-1.13-.37-5.66,2.07-10,.75-4.11-1.25-7.22,11.16-1.76,8.85C641.07,226.41,648.7,220.12,646.63,219.44Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '639.459px 224.364px 0px',
          }}
          id="elirxeo2tvheg"
          className="animable"
        />
        <path
          d="M528.76,213.5c3.34-2.29,7.14-7.34,10-8.16a3.45,3.45,0,0,1,3.91,1.32s1-3.19,3.76-3.5c1.41-.17,2.92,2,2.92,2a4.12,4.12,0,0,1,3.38-2.64c2-.11,3.18,2,3.18,2s2-2,4-1.46c4.13,1.08,6.8,17.76,1.06,21.32-2.67,1.66-3.1-2.45-3.1-2.45s-.81,6.06-4.23,6.7-3.66-4.74-3.66-4.74-.84,5.87-4.46,6.17-3.08-5.1-3.08-5.1-1.92,4.11-4.74,3.71c-4.67-.67-.2-8.58-1.66-12.11l-6.37-1.06Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '546.514px 216.294px 0px',
          }}
          id="elzf1bcofiy9h"
          className="animable"
        />
        <path
          d="M533.48,209.32c-3.36,1.89-8.47-1.82-11.94-.47-4.69,1.83,1,6.54,8.2,6.63l5.65-.92Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '527.61px 212.013px 0px',
          }}
          id="el7a904ubu12e"
          className="animable"
        />
        <path
          d="M556.19,204.82a0,0,0,1,1,.08,0A29.29,29.29,0,0,1,558,222.13c0,.19-.36.2-.35,0A60.23,60.23,0,0,0,556.19,204.82Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '557.393px 213.548px 0px',
          }}
          id="el9i582o4vice"
          className="animable"
        />
        <path
          d="M549.41,205c0-.07.09-.09.12,0a27.44,27.44,0,0,1,.7,19c-.08.22-.37.34-.3.08C551.13,219.83,550.73,210.33,549.41,205Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '550.503px 214.584px 0px',
          }}
          id="el3p5w9kt4qhn"
          className="animable"
        />
        <path
          d="M542.2,225.34c1.94-6.1,1.73-12.22.61-18.46,0-.09.11-.1.14,0,1.38,2.9,1.68,7,1.64,10.14a16.84,16.84,0,0,1-2.18,8.42C542.36,225.52,542.16,225.48,542.2,225.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '543.394px 216.145px 0px',
          }}
          id="el36q9kda8cl4"
          className="animable"
        />
        <path
          d="M509.83,240.61c-3.18.43-8.69-5.3-10.41-9.36a65,65,0,0,1,1.22-6.38c.4-2.05.79-4.34,1-6.45l12.94,4.52a34,34,0,0,0-2.08,8,4.31,4.31,0,0,0,0,.88s0,.09,0,.14C512.61,233.63,512.9,240.19,509.83,240.61Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '507px 229.526px 0px',
          }}
          id="el39tm5iyq6zh"
          className="animable"
        />
        <path
          d="M512.5,231.81s0,.09,0,.15a8.34,8.34,0,0,1-1.38-.07c-7.77-1.08-8.94-10-9.11-13.33L514.58,223a34.14,34.14,0,0,0-2.09,8A5.13,5.13,0,0,0,512.5,231.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '508.295px 225.262px 0px',
          }}
          id="elt8e20n5dbf"
          className="animable"
        />
        <path
          d="M499.68,202.86c-1.6,4.67.45,18.39,3.71,21.54,4.72,4.56,12.67,5.24,16.61-.49,3.81-5.55.83-23.37-2.83-26.26C511.78,193.41,502,196,499.68,202.86Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '510.449px 211.803px 0px',
          }}
          id="el30xtcibwnq8"
          className="animable"
        />
        <path
          d="M513.22,211.54s-.07.05-.06.09c.15.92.17,2-.63,2.42,0,0,0,.06,0,0C513.55,213.83,513.51,212.39,513.22,211.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '512.964px 212.808px 0px',
          }}
          id="eltlle6zgn8pn"
          className="animable"
        />
        <path
          d="M512.27,210.68c-1.51.08-1.23,3.09.16,3S513.53,210.61,512.27,210.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '512.304px 212.18px 0px',
          }}
          id="el77vf3yipkq3"
          className="animable"
        />
        <path
          d="M518.44,211.05s.08,0,.08.07c.06.94.28,2,1.15,2.23,0,0,0,.05,0,.05C518.62,213.35,518.35,211.94,518.44,211.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '519.047px 212.225px 0px',
          }}
          id="elyp14dl7vaia"
          className="animable"
        />
        <path
          d="M519.18,210c1.49-.25,1.88,2.74.5,3S517.94,210.21,519.18,210Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '519.477px 211.5px 0px',
          }}
          id="elmjukrloh3d"
          className="animable"
        />
        <path
          d="M511,209.42a11.38,11.38,0,0,0,1.12-.52,2,2,0,0,0,1-.74.63.63,0,0,0-.17-.76,1.58,1.58,0,0,0-1.6,0,2.29,2.29,0,0,0-1.25,1.12A.69.69,0,0,0,511,209.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '511.615px 208.327px 0px',
          }}
          id="elr78xli88kb"
          className="animable"
        />
        <path
          d="M520.21,208.38a10,10,0,0,1-1.22-.2,2,2,0,0,1-1.21-.44.63.63,0,0,1,0-.78,1.6,1.6,0,0,1,1.54-.44,2.39,2.39,0,0,1,1.49.76A.68.68,0,0,1,520.21,208.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '519.301px 207.428px 0px',
          }}
          id="elbsdtt0x6ilm"
          className="animable"
        />
        <path
          d="M513,220.08c.24.2.49.48.83.48a2.65,2.65,0,0,0,1-.33s.06,0,0,0a1.27,1.27,0,0,1-1.13.62,1,1,0,0,1-.81-.76S513,220.05,513,220.08Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '513.873px 220.46px 0px',
          }}
          id="elkoigqhtekd"
          className="animable"
        />
        <path
          d="M513.73,217.21a3.16,3.16,0,0,0,2.24,1.21,4,4,0,0,0,1.15,0l.21,0,.2-.05a.24.24,0,0,0,.17-.23h0a.3.3,0,0,0,0-.1h0v-.08c0-.72-.21-1.8-.21-1.8.27.11,1.66.59,1.61.22A47.88,47.88,0,0,0,517,206.8a.09.09,0,0,0-.17,0c.34,3,1.19,5.88,1.57,8.87a5.37,5.37,0,0,0-1.53-.32c-.1,0,.36,2.09.35,2.41,0,0,0,0,0,0a4.38,4.38,0,0,1-3.37-.71C513.74,217.07,513.67,217.14,513.73,217.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '516.405px 212.601px 0px',
          }}
          id="el0q57mt2lhkqe"
          className="animable"
        />
        <path
          d="M516.66,218.05a3.72,3.72,0,0,1-1.4,1.3,1.76,1.76,0,0,1-1,.16c-.76-.13-.84-.81-.75-1.4a3.83,3.83,0,0,1,.25-.93A4.85,4.85,0,0,0,516.66,218.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '515.07px 218.353px 0px',
          }}
          id="el9ead4kgvm2f"
          className="animable"
        />
        <path
          d="M515.26,219.35a1.76,1.76,0,0,1-1,.16c-.76-.13-.84-.81-.75-1.4A1.72,1.72,0,0,1,515.26,219.35Z"
          style={{
            fill: 'rgb(255, 151, 184)',
            transformOrigin: '514.37px 218.816px 0px',
          }}
          id="ell3fjgck7gjb"
          className="animable"
        />
        <g id="el1k14ir4h02a">
          <path
            d="M502.51,198.66c.19,1.84.64,7.55-.05,8.84s-2.14,4.24-3,4.81c-.46-3.78-.44-7.45.24-9.45A9.71,9.71,0,0,1,502.51,198.66Z"
            style={{
              fill: 'rgb(38, 50, 56)',
              opacity: '0.2',
              transformOrigin: '500.989px 205.485px 0px',
            }}
            className="animable"
            id="elcqi2gmfoq2l"
          />
        </g>
        <path
          d="M514.29,202.18a4.58,4.58,0,0,1-4,2,4.67,4.67,0,0,1-3.88-2.34c0-.05-.08,0-.06,0a4.6,4.6,0,0,0,3.92,2.68,4.7,4.7,0,0,0,4.07-2.33C514.42,202.18,514.33,202.12,514.29,202.18Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '510.359px 203.169px 0px',
          }}
          id="eltbzmoddakyq"
          className="animable"
        />
        <path
          d="M508.29,191.56a7.17,7.17,0,0,0-5.61,4,5.14,5.14,0,0,0-.1,3.37s.1,0,.09,0a5.61,5.61,0,0,1,2-5.35A7.23,7.23,0,0,1,511,192a4.54,4.54,0,0,1,2.67,1.68c.07.09.26,0,.2-.09C513,192.08,510.66,191.23,508.29,191.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '508.113px 195.21px 0px',
          }}
          id="elssojoab79jk"
          className="animable"
        />
        <path
          d="M524.2,195.45a5.88,5.88,0,0,0-2.83-2.82c-1.73-.81-3.53-.44-5.32,0,0,0,0,.09,0,.08a8.11,8.11,0,0,1,4.58,0,5.76,5.76,0,0,1,3,2.46,5.58,5.58,0,0,1-1.48,7.16,5.72,5.72,0,0,1-4.39,1,0,0,0,0,0,0,.09,5.71,5.71,0,0,0,6.5-7.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '520.398px 197.858px 0px',
          }}
          id="elgh4gizx91l"
          className="animable"
        />
        <path
          d="M499,205.63s-3-4.41-1.25-7.37c1-1.67,4.95-1.91,4.95-1.91a7.12,7.12,0,0,1,4.17-3.51c3.2-1.12,7.31.36,7.31.36s2.92-2.14,6-.8c4.33,1.87,4.52,8.12.65,10.58-2.72,1.72-6.91-.39-6.91-.39-.37.1-4,2.85-7.24-.25,0,0-2.13,2.36-4.42,1.13A3.44,3.44,0,0,1,499,205.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '510.395px 198.795px 0px',
          }}
          id="el17k48n1q8ru"
          className="animable"
        />
        <path
          d="M502.23,214.07s-3-4.45-5-3.38.22,7.5,2.56,8.4a2.39,2.39,0,0,0,3.22-1.24Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '499.731px 214.92px 0px',
          }}
          id="elr44ghri0669"
          className="animable"
        />
        <path
          d="M497.87,212.52s0,0,0,.06a6,6,0,0,1,3.07,3.82,1.31,1.31,0,0,0-2-.39c-.05,0,0,.1,0,.09a1.47,1.47,0,0,1,1.61.53,7.53,7.53,0,0,1,.76,1.32c.07.15.34.07.29-.1l0,0C501.72,215.72,500.13,212.76,497.87,212.52Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '499.738px 215.275px 0px',
          }}
          id="eldhk5gx90lr"
          className="animable"
        />
        <path
          d="M465.54,304.71c.13.17,61,5.43,61.64,4.85.85-.82-3-61.71-13.94-74.11-2.69-3-12.15-6.7-15.26-4.77-8.05,5-13,16.25-16.15,22.8-2.34,4.85-5.35,13.19-8.13,21.76C469.1,289.37,465.09,304.09,465.54,304.71Z"
          style={{ fill: '#F53B57', transformOrigin: '496.4px 269.875px 0px' }}
          id="eljhh01ezip39"
          className="animable"
        />
        <g id="elha5mwtyfohh">
          <path
            d="M501.56,254.09a8.75,8.75,0,0,0-.49,2.61,9.32,9.32,0,0,0,1.13-2.39,9.07,9.07,0,0,0,.49-2.6A8.94,8.94,0,0,0,501.56,254.09ZM477.13,270a9,9,0,0,0-.48,2.6,9.32,9.32,0,0,0,1.13-2.39,9,9,0,0,0,.48-2.6A9.5,9.5,0,0,0,477.13,270Zm35.69,35.66a9.65,9.65,0,0,0-.48,2.6,9,9,0,0,0,1.14-2.39,9.41,9.41,0,0,0,.48-2.6A9.7,9.7,0,0,0,512.82,305.61Zm-30.37.53a.42.42,0,0,1,0,.12l.71.05a9.35,9.35,0,0,0,.46-2.55A9.26,9.26,0,0,0,482.45,306.14Zm-15.88-4.87a9.66,9.66,0,0,0-.49,2.6,10.19,10.19,0,0,0,1.62-5A10.29,10.29,0,0,0,466.57,301.27Zm31.05-15.54a9.81,9.81,0,0,0-.49,2.61,8.45,8.45,0,0,0,1.14-2.39,8.85,8.85,0,0,0,.48-2.6A9.79,9.79,0,0,0,497.62,285.73Zm-9.31-42.45a9.06,9.06,0,0,0-.48,2.61,9.73,9.73,0,0,0,1.13-2.4,9.22,9.22,0,0,0,.49-2.59A9.29,9.29,0,0,0,488.31,243.28Zm32.29,10.77h0a9,9,0,0,0-2.59-.5,8.68,8.68,0,0,0,2.38,1.14l.44.12C520.73,254.55,520.67,254.3,520.6,254.05Zm-39.76,34.36a9.81,9.81,0,0,0-2.6-.49,8.6,8.6,0,0,0,2.39,1.14,8.94,8.94,0,0,0,2.6.49A9.36,9.36,0,0,0,480.84,288.41Zm46.28,18.22a8.94,8.94,0,0,0-2.61-.48,9.54,9.54,0,0,0,2.4,1.13c.13,0,.25.08.38.12,0-.23,0-.46,0-.71Zm-22.64-8.85a8.94,8.94,0,0,0-2.6-.48,9.38,9.38,0,0,0,2.4,1.13,8.94,8.94,0,0,0,2.6.49A9.58,9.58,0,0,0,504.48,297.78Zm16.44-18.44a9.65,9.65,0,0,0-2.59-.48,8.94,8.94,0,0,0,2.38,1.13,9.14,9.14,0,0,0,2.61.49A9.77,9.77,0,0,0,520.92,279.34ZM496.25,265.7a9.29,9.29,0,0,0-2.61-.49,9.24,9.24,0,0,0,2.4,1.14,9.42,9.42,0,0,0,2.6.49A9,9,0,0,0,496.25,265.7ZM475.7,299.25a8.88,8.88,0,0,0-1.49-2.18,9.34,9.34,0,0,0,.88,2.49,9.58,9.58,0,0,0,1.49,2.18A9.1,9.1,0,0,0,475.7,299.25Zm25.46-63.43a9.07,9.07,0,0,0-1.49-2.18,10.21,10.21,0,0,0,2.38,4.67A9.12,9.12,0,0,0,501.16,235.82Zm12.94,28.52a9.48,9.48,0,0,0-1.49-2.18,9.28,9.28,0,0,0,.88,2.5,9.11,9.11,0,0,0,1.5,2.18A9.3,9.3,0,0,0,514.1,264.34Zm-16.89,41.87a9.27,9.27,0,0,0-1.49-2.18,9.34,9.34,0,0,0,.88,2.49c.18.33.36.66.57,1l.62.05A12.31,12.31,0,0,0,497.21,306.21ZM511.9,288a9.86,9.86,0,0,0-1.49-2.19,9.28,9.28,0,0,0,.88,2.5,9.42,9.42,0,0,0,1.49,2.19A9.17,9.17,0,0,0,511.9,288Zm-23.58-10.83a9.08,9.08,0,0,0-1.5-2.19,9.53,9.53,0,0,0,.89,2.5,9.31,9.31,0,0,0,1.5,2.18A9.24,9.24,0,0,0,488.32,277.16Zm-16.84,5.07c-.08.29-.18.59-.27.88l.24-.11a9.16,9.16,0,0,0,2.18-1.49A8.25,8.25,0,0,0,471.48,282.23ZM490,295.54a9.7,9.7,0,0,0-2.2,1.49,9.25,9.25,0,0,0,2.51-.89,9,9,0,0,0,2.17-1.49A9.05,9.05,0,0,0,490,295.54Zm-4.88-37.39a9,9,0,0,0-2.17,1.49,9.34,9.34,0,0,0,2.49-.88,9.07,9.07,0,0,0,2.18-1.51A9.55,9.55,0,0,0,485.15,258.15ZM520.38,297a9.42,9.42,0,0,0-2.19,1.49,9.12,9.12,0,0,0,2.49-.89,8.84,8.84,0,0,0,2.19-1.49A9.12,9.12,0,0,0,520.38,297Zm-12.92-22.19a9.42,9.42,0,0,0-2.19,1.49,9.22,9.22,0,0,0,2.49-.88,8.79,8.79,0,0,0,2.18-1.49A9.15,9.15,0,0,0,507.46,274.84Zm6-32.5a9.31,9.31,0,0,0-2.18,1.5,9.81,9.81,0,0,0,2.49-.88,9.47,9.47,0,0,0,2.19-1.5A9.28,9.28,0,0,0,513.43,242.34Z"
            style={{
              opacity: '0.1',
              transformOrigin: '496.685px 270.95px 0px',
            }}
            className="animable"
            id="elb5zlbbnhgpf"
          />
        </g>
        <path
          d="M510.86,248.62c12.69,9.81,37.25,27,48.29,24.13,11.71-3.05,22.59-20.57,27.76-26.61,2.2-2.56-19.14-14.82-22.08-12.72s-9.93,13.77-12.38,14.9-23.11-7.61-36.64-11.32C499.91,232.64,500.55,240.65,510.86,248.62Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '545.254px 253.124px 0px',
          }}
          id="eljuno3k0874k"
          className="animable"
        />
        <path
          d="M572.31,209.37a4,4,0,0,1,4,2.2,5.84,5.84,0,0,1,3.76-1.35c2.41.11,3.29,3.95,3.29,3.95a7.18,7.18,0,0,1,4.19-.79c2.3.34,3.74,4.09,3.74,4.09a6.37,6.37,0,0,1,4.13,1.62c2.92,2.84,1.61,8.93.82,12.81s-9.21,15.44-10.85,16.18l-23.17-8.66s-1.43-10,1.66-19C565.12,216.64,569.25,209.79,572.31,209.37Z"
          style={{
            fill: 'rgb(173, 99, 89)',
            transformOrigin: '579.558px 228.714px 0px',
          }}
          id="eli5153wrz9c"
          className="animable"
        />
        <path
          d="M575.83,211.66c-2.37,3.63-3.54,7.76-4.94,11.81a.07.07,0,0,0,.14.05c1.35-4.05,3.48-7.78,5-11.77A.1.1,0,0,0,575.83,211.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '573.463px 217.582px 0px',
          }}
          id="elna4i43phv3"
          className="animable"
        />
        <path
          d="M583,214.19a11.23,11.23,0,0,0-1,2.77c-.29,1-.56,2-.82,3q-.78,3-1.4,6.13c0,.09.12.14.14,0,.52-2,1.07-4,1.67-6l.93-3a12.78,12.78,0,0,0,.77-2.85A.15.15,0,0,0,583,214.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '581.535px 220.136px 0px',
          }}
          id="elf367fys1q8p"
          className="animable"
        />
        <path
          d="M591.22,217.55a7.72,7.72,0,0,0-.78,2.55c-.22.93-.44,1.86-.67,2.79-.45,1.85-.91,3.7-1.42,5.54a.07.07,0,0,0,.14,0c.53-1.87,1.09-3.72,1.61-5.59q.39-1.38.75-2.76a7.28,7.28,0,0,0,.46-2.56A.05.05,0,0,0,591.22,217.55Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '589.83px 223px 0px',
          }}
          id="els0n9hc9o9ft"
          className="animable"
        />
        <path
          d="M560.63,237.12l23.31,18s-15.92,19.55-28.37,19.3-37.76-18.07-47.13-27-6-14.73,6.66-11.15,35.52,11.14,36.33,11.17S560.63,237.12,560.63,237.12Z"
          style={{ fill: '#F53B57', transformOrigin: '543.513px 254.81px 0px' }}
          id="el02u7rgjsoklm"
          className="animable"
        />
        <g id="eln72yg5mv0ph">
          <path
            d="M513.57,242.35a10.15,10.15,0,0,0-1.62,2.09,10.16,10.16,0,0,0,3.74-3.7A9.41,9.41,0,0,0,513.57,242.35Zm44.59,20.59a9.32,9.32,0,0,0-1.63,2.09,10.16,10.16,0,0,0,3.73-3.71A9.05,9.05,0,0,0,558.16,262.94Zm4.79-24c-.29.23-.55.48-.81.73a9.61,9.61,0,0,0-1.63,2.09,9.41,9.41,0,0,0,2.12-1.61c.27-.28.53-.56.78-.87Zm-23.88,11.94a9.67,9.67,0,0,0-2.1-1.63,9.14,9.14,0,0,0,1.61,2.11,9.28,9.28,0,0,0,2.09,1.62A9.55,9.55,0,0,0,539.07,250.86Zm15,22.68a9.06,9.06,0,0,0-2.09-1.62,9.76,9.76,0,0,0,1.61,2.1c.1.09.19.19.29.27l1,.09C554.6,274.08,554.34,273.81,554.08,273.54ZM565,251.66a9.76,9.76,0,0,0-2.08-1.62,9.25,9.25,0,0,0,1.6,2.11,9.82,9.82,0,0,0,2.09,1.62A9.35,9.35,0,0,0,565,251.66Zm-20.72,12.53a9.18,9.18,0,0,0-2.63.34,9.55,9.55,0,0,0,2.63.34,9.13,9.13,0,0,0,2.63-.33A9.51,9.51,0,0,0,544.25,264.19Zm36.44-11.59c-.42,0-.83-.07-1.26-.09a9.13,9.13,0,0,0-2.62.35,9.89,9.89,0,0,0,2.63.34,10.46,10.46,0,0,0,1.84-.15Zm-56.75-1.3a8.77,8.77,0,0,0-2.62.33,10.16,10.16,0,0,0,5.25,0A9.5,9.5,0,0,0,523.94,251.3Zm9,11.39a9.07,9.07,0,0,0,.34,2.62,10.12,10.12,0,0,0,0-5.24A9.39,9.39,0,0,0,533,262.69Zm20.31-10.27a8.83,8.83,0,0,0,.33,2.63,9.51,9.51,0,0,0,.35-2.63,9.12,9.12,0,0,0-.34-2.62A9,9,0,0,0,553.3,252.42Zm15.77,12a10.25,10.25,0,0,0,.33,2.63,8.81,8.81,0,0,0,.36-2.62,9.14,9.14,0,0,0-.34-2.63A9.89,9.89,0,0,0,569.07,264.39Z"
            style={{ opacity: '0.1', transformOrigin: '546.63px 256.67px 0px' }}
            className="animable"
            id="elb6uk29hkaz"
          />
        </g>
        <path
          d="M567.83,250.3c-1.62-1.33-3.27-2.62-4.92-3.91-.79-.62-1.58-1.25-2.39-1.84s-1.72-1.36-2.63-1.94a.06.06,0,0,0-.08.09c.75.78,1.63,1.46,2.42,2.19s1.52,1.33,2.28,2c1.6,1.36,3.19,2.71,4.81,4,3.26,2.65,6.57,5.19,9.93,7.7a.08.08,0,0,0,.1-.12C574.22,255.7,571.07,253,567.83,250.3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '567.578px 250.597px 0px',
          }}
          id="elkokme617snn"
          className="animable"
        />
        <path
          d="M531.16,264.33c-2.09-1.43-10.16-7.33-11.63-8.44-3-2.25-5.92-4.53-8.89-6.78a0,0,0,0,0-.05,0c1.6,1.57,3.27,3.06,5,4.49l-.4-.23c-.84-.47-1.7-.9-2.55-1.34,0,0-.09.06,0,.09.82.52,1.64,1.06,2.49,1.55.53.31,1.08.59,1.63.87.76.62,1.53,1.22,2.3,1.82,1.5,1.14,9.52,7.07,12,8C531.16,264.49,531.24,264.39,531.16,264.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '520.891px 256.767px 0px',
          }}
          id="elavb3sipmxjn"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-1--inject-12"
        style={{ transformOrigin: '228.293px 282.903px 0px' }}
        className="animable"
      >
        <path
          d="M205.75,158.64c-.21-2.23-.35-4.48-.37-6.74a61.45,61.45,0,0,1-.18-9.69c.34-5.31,1.1-11.72,6.13-14.7a18.93,18.93,0,0,1,7.68-2.23c2.76-.3,5.72-.32,8.22,1.08a7.2,7.2,0,0,1,2.47,2.25,17.68,17.68,0,0,1,5.17,2.64c2,1,3.21,3.27,4,5.26a29.48,29.48,0,0,1,1.64,7.5,17.94,17.94,0,0,1-.27,7,37.8,37.8,0,0,1-2.46,5.8,21.82,21.82,0,0,0-2.37,7.19c0,.09-.14.09-.13,0,.28-4.1,2.67-7.62,4-11.39a16,16,0,0,0,1-6.69,39.08,39.08,0,0,0-1.22-7.76,12.9,12.9,0,0,0-3.32-6.13l.09.08c1.92,2.09,2.65,4.95,3.11,7.67a31.43,31.43,0,0,1,.42,9.23,30.16,30.16,0,0,1-2.46,8,31.88,31.88,0,0,0-2.63,8,24.3,24.3,0,0,0,.85,8.77,35.18,35.18,0,0,1,1.32,8.45,12.41,12.41,0,0,1-2.41,7.21c-2.87,3.85-8.9,6.71-13.24,3.48a15.44,15.44,0,0,1-2.82-2.89,37.47,37.47,0,0,1-2.52-3.51,49.24,49.24,0,0,1-4.14-8.2,92,92,0,0,1-4.7-17.6c-.26-1.47-.5-3-.71-4.44a87.64,87.64,0,0,0,1.34,10,62.21,62.21,0,0,0,5.66,17.46,38.75,38.75,0,0,0,2.49,4c1,1.42,2.11,2.71,3.19,4,.07.08,0,.19-.11.12a31.51,31.51,0,0,1-5.29-7,43.1,43.1,0,0,1-3.66-8.28A82.75,82.75,0,0,1,205.75,158.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '222.911px 159.718px 0px',
          }}
          id="elvhddv8yeqbr"
          className="animable"
        />
        <path
          d="M226.11,171c1.54,11.4,10,38.48,16.38,40.2,5.9,1.6,31.87-6.13,35.21-11.28,1.79-2.76,8.87-28.09,5.7-26.58-4,1.92-33.41,16.78-34.62,16.47-2.55-.64-7.53-10.69-11.83-16.31C227.57,161.19,225.39,165.62,226.11,171Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '255.095px 188.505px 0px',
          }}
          id="eljiedti1ui3"
          className="animable"
        />
        <path
          d="M243.85,182.27l-13.31,12.2S225.83,177,225.29,169,231.36,161.83,243.85,182.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '234.555px 179.381px 0px',
          }}
          id="elscflqemfml"
          className="animable"
        />
        <g id="elqj3m4cd02vq">
          <rect
            x="215.75"
            y="122.44"
            width="31.79"
            height="185.3"
            style={{
              fill: '#F53B57',
              transformOrigin: '231.645px 215.09px 0px',
              transform: 'rotate(-143.08deg)',
            }}
            className="animable"
            id="el64z80jxgetu"
          />
        </g>
        <g id="elr98ncbqak9c">
          <rect
            x="153.97"
            y="287.11"
            width="31.79"
            height="20.38"
            style={{
              fill: 'rgb(255, 151, 184)',
              transformOrigin: '169.865px 297.3px 0px',
              transform: 'rotate(-143.08deg)',
            }}
            className="animable"
            id="elrf7uvnv0zl"
          />
        </g>
        <g id="ele5wyatndafa">
          <rect
            x="159.04"
            y="283.33"
            width="37.12"
            height="7.37"
            style={{
              fill: 'rgb(55, 71, 79)',
              transformOrigin: '177.6px 287.015px 0px',
              transform: 'rotate(-143.08deg)',
            }}
            className="animable"
            id="elm4s1oiipko"
          />
        </g>
        <g id="elp1zqbj35z4g">
          <rect
            x="163.93"
            y="276.82"
            width="37.12"
            height="7.37"
            style={{
              fill: 'rgb(55, 71, 79)',
              transformOrigin: '182.49px 280.505px 0px',
              transform: 'rotate(-143.08deg)',
            }}
            className="animable"
            id="elire31v7x3r"
          />
        </g>
        <path
          d="M274.57,131.47l23.31-11.1,7.67-3.69-1.35,8.43L300,150.59l-5.35,1.75s.27-5.48.26-5.58l-5.35,1.76s.27-5.48.26-5.58l-5.29,1.8s.22-5.53.2-5.63l-5.29,1.8s.22-5.52.2-5.62l-5.29,1.8S274.59,131.56,274.57,131.47Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '289.95px 134.51px 0px',
          }}
          id="el9szdx821uzp"
          className="animable"
        />
        <polygon
          points="297.88 120.37 305.55 116.68 304.19 125.11 297.88 120.37"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '301.715px 120.895px 0px',
          }}
          id="elu0k1qzx3ix"
          className="animable"
        />
        <g id="el3uu67deoitw">
          <g
            style={{ opacity: '0.1', transformOrigin: '234.98px 210.65px 0px' }}
            className="animable"
            id="elvvedl937lwe"
          >
            <path
              d="M199.67,271.49q10.34-14.3,20.87-28.43l21.09-28.27,21.28-28.12,10.7-14,10.8-13.95L274,173l-10.48,14.18-21.09,28.27-21.28,28.12Q210.48,257.56,199.67,271.49Z"
              id="eloh2ulukvltg"
              style={{ transformOrigin: '242.04px 215.105px 0px' }}
              className="animable"
            />
            <path
              d="M192.61,267q10.33-14.29,20.87-28.43l21.09-28.27,21.28-28.12,10.71-14,10.79-13.94L267,168.5l-10.47,14.19L235.39,211l-21.28,28.12Q203.41,253.09,192.61,267Z"
              id="elw4nissgr1r"
              style={{ transformOrigin: '234.98px 210.62px 0px' }}
              className="animable"
            />
            <path
              d="M185.55,262.57q10.35-14.28,20.87-28.43l21.09-28.26,21.28-28.13,10.71-14,10.8-13.94-10.39,14.25-10.48,14.18L228.34,206.5l-21.28,28.12C199.93,244,192.79,253.3,185.55,262.57Z"
              id="elmadfrqbvu8"
              style={{ transformOrigin: '227.925px 206.19px 0px' }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M285.92,172.38c.37,3.94,2.88,9.58,2.21,12.45a3.39,3.39,0,0,1-3,2.72s2.24,2.36,1.21,4.86c-.54,1.29-3.06,1.57-3.06,1.57a4,4,0,0,1,.66,4.14c-.85,1.73-3.25,1.75-3.25,1.75s.76,2.66-.66,4.15c-2.89,3-18.4-2.63-18.72-9.21-.15-3.07,3.56-1.49,3.56-1.49s-4.79-3.57-3.71-6.79,5.78-.88,5.78-.88-4.61-3.5-3.15-6.74,5.81-.21,5.81-.21-2.6-3.59-.91-5.81c2.78-3.67,7.42,3.9,11.12,4.33l3.93-4.94Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '274.622px 188.369px 0px',
          }}
          id="eljx6ew5m9uej"
          className="animable"
        />
        <path
          d="M287.25,178.4c0-3.77,5.57-6.37,6.06-10,.67-4.88-6-2.29-9.55,3.86l-1.89,5.26Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '287.613px 172.126px 0px',
          }}
          id="eliohebnuvcd"
          className="animable"
        />
        <path
          d="M280.33,199.93a0,0,0,0,1,0,.09,28.65,28.65,0,0,1-15.63-6.76c-.14-.13,0-.4.18-.29A58.55,58.55,0,0,0,280.33,199.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '272.486px 196.482px 0px',
          }}
          id="el39d8i4ku0m"
          className="animable"
        />
        <path
          d="M283.36,194a.06.06,0,0,1,0,.11,26.81,26.81,0,0,1-16.6-8.43c-.15-.17-.11-.47.07-.29C269.9,188.49,278.21,192.65,283.36,194Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '275.032px 189.722px 0px',
          }}
          id="elrrxv60jsz6"
          className="animable"
        />
        <path
          d="M269.42,178.25c4.3,4.55,9.62,7.27,15.49,9.28.08,0,0,.13,0,.13-3.14-.2-6.74-1.87-9.44-3.41a16.48,16.48,0,0,1-6.16-5.85C269.21,178.3,269.33,178.15,269.42,178.25Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '277.109px 182.939px 0px',
          }}
          id="elizrjb3p636k"
          className="animable"
        />
        <path
          d="M293.7,446.12c-2.05.61-60.06-1.34-62.21-2.82-.83-.55-1-9-1-19.26v-.32c0-2.11,0-4.28.07-6.48,0-.3,0-.61,0-.91.22-14.77.77-30.1.77-30.1l38.31.95-1.29,30-.07,1.18-.36,6.16,0,.64s21.87,10.68,24.08,12.55S295.75,445.51,293.7,446.12Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '262.576px 416.232px 0px',
          }}
          id="el4xn5t4rhkfu"
          className="animable"
        />
        <path
          d="M277.48,429.3c-.13-.05-.21-.09-.22-.13Z"
          style={{ fill: '#F53B57', transformOrigin: '277.37px 429.235px 0px' }}
          id="el7qqcvpsorin"
          className="animable"
        />
        <path
          d="M294.83,446.52c-1.36.4-26.46-.3-44.73-1.25-4.22-.22-8.08-.46-11.2-.69-4.29-.34-7.17-.66-7.63-1-.79-.55-1.28-24.26-1-27l38.24,1.27-.06,7.3S290.8,436.06,293.05,438,296.91,445.89,294.83,446.52Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '262.992px 431.607px 0px',
          }}
          id="elv3fy0jv4ev"
          className="animable"
        />
        <path
          d="M293.51,444.1c-9.92-.58-50-2-59.86-1.82-.08,0-.08.05,0,.06,9.82.79,49.91,1.89,59.85,1.93C293.71,444.27,293.72,444.12,293.51,444.1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '263.626px 443.267px 0px',
          }}
          id="elec5xrcnq0xn"
          className="animable"
        />
        <path
          d="M269.4,423c-3.88-.86-8.68-.43-11.77,2.26-.12.1,0,.27.16.23a55.38,55.38,0,0,1,11.58-2A.25.25,0,0,0,269.4,423Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '263.584px 424.048px 0px',
          }}
          id="elvxwmppozhon"
          className="animable"
        />
        <path
          d="M272.16,424.76c-3.88-.87-8.68-.43-11.76,2.25-.12.11,0,.28.15.24a55.38,55.38,0,0,1,11.58-2A.25.25,0,0,0,272.16,424.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '266.349px 425.806px 0px',
          }}
          id="el7j6wcl21bew"
          className="animable"
        />
        <path
          d="M274.92,426.56c-3.88-.87-8.68-.43-11.76,2.25-.12.1,0,.27.16.24a54.53,54.53,0,0,1,11.57-2A.25.25,0,0,0,274.92,426.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '269.109px 427.605px 0px',
          }}
          id="elmzrssiubarj"
          className="animable"
        />
        <path
          d="M277.69,428.35c-3.89-.86-8.69-.43-11.77,2.26-.12.1,0,.27.16.23a55.4,55.4,0,0,1,11.57-2A.25.25,0,0,0,277.69,428.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '271.873px 429.398px 0px',
          }}
          id="elim6uasw5jfr"
          className="animable"
        />
        <path
          d="M276.93,414.17c-1.47-2.17-4.36-1.31-6,0a20.79,20.79,0,0,0-6.32,8.75.1.1,0,0,0,.08.14c0,.3.26.62.6.51,3.27-1.08,6.9-1.84,9.73-3.89C276.64,418.48,278.31,416.22,276.93,414.17Zm-7.06,6.74c-1.6.58-3.21,1.07-4.78,1.7a62.06,62.06,0,0,1,3.81-5,23.06,23.06,0,0,1,2.14-2.17c1.2-1,5.88-3.11,5,1.16C275.63,418.92,271.77,420.23,269.87,420.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '271.022px 418.219px 0px',
          }}
          id="eltatxgcacwd"
          className="animable"
        />
        <path
          d="M254.67,421.56c3.17,1.48,6.88,1.54,10.29,2a.49.49,0,0,0,.49-.62.1.1,0,0,0,.06-.15,20.85,20.85,0,0,0-7.86-7.4c-1.9-1-4.9-1.27-5.93,1.14S252.82,420.69,254.67,421.56ZM253,418.71c-1.62-4,3.37-2.86,4.74-2.08a22.72,22.72,0,0,1,2.51,1.72,60.55,60.55,0,0,1,4.69,4.22c-1.66-.32-3.34-.5-5-.76C257.93,421.5,253.9,420.93,253,418.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '258.488px 419.11px 0px',
          }}
          id="el39uh4hj93m2"
          className="animable"
        />
        <path
          d="M210.11,217.37s20.19,101.38,21.61,108.86c.23,1.21-5.09,41.85-5.36,64.48a27.69,27.69,0,0,0,4.26,15.47l40,1.8s4.39-5.93,4.48-12c.3-19.58-3.54-60.1-4.92-71.5-1.81-14.95-24.67-107.09-24.67-107.09Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '242.613px 312.675px 0px',
          }}
          id="el5aihbwd8br4"
          className="animable"
        />
        <path
          d="M232.76,398.76c6.38.08,4.55,0,10.93.12,3.13.08,23.65.6,26.55,1.18.06,0,.06.12,0,.13-2.94.38-23.45-.49-26.57-.63-6.38-.28-4.55-.27-10.92-.62C232.63,398.94,232.64,398.76,232.76,398.76Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '251.475px 399.523px 0px',
          }}
          id="eldp9kiooho7c"
          className="animable"
        />
        <path
          d="M237,326.54a155.75,155.75,0,0,0-2.77-16.6Q232.56,301.5,231,293c-2.12-11.15-4.19-22.31-6.33-33.46-2.42-12.6-5.87-24.91-8.42-37.49-.06-.29-.49-.15-.44.13,4,22.37,9.21,44.39,13.43,66.71l3.21,16.89c1,5.5,2.21,11,3.1,16.5a46.51,46.51,0,0,1,.62,8.66c-.08,2.73-.36,5.46-.61,8.18-.52,5.71-1.05,11.42-1.55,17.14q-.82,9.42-1.63,18.85c-.54,6.39-1.13,12.79-1.45,19.19,0,.09.13.1.14,0,1.5-11.27,2.4-22.65,3.47-34q.81-8.56,1.59-17.14C236.6,337.72,237.4,332.1,237,326.54Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '226.457px 308.131px 0px',
          }}
          id="elz1h1ri0nkln"
          className="animable"
        />
        <path
          d="M241.3,217.37l-12.6,93.49c-6-30.28-18.59-93.49-18.59-93.49Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '225.705px 264.115px 0px',
          }}
          id="el3lgfak1rmx"
          className="animable"
        />
        <path
          d="M226.3,448.63c-2.08.51-59.91-4.35-62-5.94-.81-.59-.59-9.05,0-19.28,0-.11,0-.21,0-.32.11-2.11.23-4.28.39-6.47,0-.3,0-.61.05-.91l7.19-30,38.7,3.14-8.19,29.66-.13,1.18-.67,6.14-.06.63s21.3,11.76,23.41,13.75S228.38,448.12,226.3,448.63Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '195.565px 417.189px 0px',
          }}
          id="eltyfzflmdlih"
          className="animable"
        />
        <path
          d="M211,431c-.14-.05-.21-.09-.22-.13Z"
          style={{ fill: '#F53B57', transformOrigin: '210.89px 430.935px 0px' }}
          id="el4dw5fgy9r28"
          className="animable"
        />
        <path
          d="M227.4,449.09c-1.37.33-26.41-1.63-44.6-3.5-4.21-.43-8.05-.86-11.15-1.25-4.28-.55-7.13-1-7.58-1.35-.76-.59-.06-24.29.38-27.06l38.14,3.2-.44,7.28s21.76,12,23.91,14S229.52,448.56,227.4,449.09Z"
          style={{
            fill: '#F53B57',
            transformOrigin: '196.105px 432.528px 0px',
          }}
          id="el2gsk162pf3x"
          className="animable"
        />
        <path
          d="M226.21,446.61c-9.88-1.08-49.84-4.51-59.69-4.83-.08,0-.08.05,0,.06,9.77,1.29,49.75,4.39,59.68,4.93C226.41,446.78,226.42,446.63,226.21,446.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '196.411px 444.275px 0px',
          }}
          id="elmjvcelesnmb"
          className="animable"
        />
        <path
          d="M203.19,424.28c-3.83-1-8.65-.86-11.86,1.66-.13.1,0,.28.14.25a55.18,55.18,0,0,1,11.67-1.42A.25.25,0,0,0,203.19,424.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '197.324px 424.947px 0px',
          }}
          id="elutqgkc9027p"
          className="animable"
        />
        <path
          d="M205.86,426.22c-3.83-1.06-8.65-.87-11.86,1.66-.13.1,0,.27.14.24a55.16,55.16,0,0,1,11.66-1.41A.25.25,0,0,0,205.86,426.22Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '199.993px 426.868px 0px',
          }}
          id="elonwdbg8kd1m"
          className="animable"
        />
        <path
          d="M208.53,428.15c-3.83-1.06-8.65-.86-11.86,1.66-.13.1,0,.27.14.25a54.53,54.53,0,0,1,11.66-1.42A.25.25,0,0,0,208.53,428.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '202.663px 428.803px 0px',
          }}
          id="elxvztfb2ys"
          className="animable"
        />
        <path
          d="M211.2,430.08c-3.84-1.05-8.65-.86-11.86,1.66-.13.1,0,.28.14.25a55.09,55.09,0,0,1,11.66-1.42A.25.25,0,0,0,211.2,430.08Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '205.333px 430.736px 0px',
          }}
          id="el0junpnn1trje"
          className="animable"
        />
        <path
          d="M211.15,415.88c-1.35-2.24-4.28-1.53-6-.3a20.8,20.8,0,0,0-6.76,8.42.11.11,0,0,0,.08.15.48.48,0,0,0,.57.53c3.32-.92,7-1.49,9.92-3.4C210.65,420.17,212.43,418,211.15,415.88Zm-7.39,6.38c-1.62.49-3.25.9-4.85,1.45a62,62,0,0,1,4.05-4.83,23,23,0,0,1,2.25-2.05c1.25-1,6-2.82,5,1.4C209.61,420.56,205.7,421.67,203.76,422.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '204.984px 419.557px 0px',
          }}
          id="elgemmurvz2f"
          className="animable"
        />
        <path
          d="M188.55,422.14c3.1,1.64,6.79,1.88,10.18,2.51.35.06.56-.3.52-.59a.11.11,0,0,0,.07-.16,20.91,20.91,0,0,0-7.48-7.78c-1.85-1.07-4.83-1.51-6,.84S186.74,421.18,188.55,422.14ZM187,419.21c-1.42-4.1,3.5-2.68,4.83-1.84a21.92,21.92,0,0,1,2.43,1.85c1.61,1.37,3,2.93,4.47,4.45-1.65-.41-3.31-.67-5-1C191.81,422.24,187.81,421.48,187,419.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '192.416px 419.955px 0px',
          }}
          id="el45vys0u57jp"
          className="animable"
        />
        <path
          d="M205.34,411.49l-38.88-4.32S162.67,397,165,387.26c4.93-20.46,18.93-51.91,19.93-55.52,1.52-5.5,4.92-49.8,8.22-77.18,0,0-6.26-14.82,5.45-37.22h47s-3.15,21.31-8.54,34.82c0,0,1-.76-5.34,2.73,0,0-3.89,69.58-6.73,82.75-2.35,10.87-6.44,45.72-11.29,63.33C212,407.2,205.34,411.49,205.34,411.49Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '204.921px 314.415px 0px',
          }}
          id="el3vp782y5l"
          className="animable"
        />
        <path
          d="M169.07,398.61c6.36.59,4.55.34,10.9,1,3.1.32,23.52,2.46,26.37,3.27.06,0,0,.13,0,.13-2.95.15-23.33-2.35-26.43-2.73-6.34-.78-4.51-.63-10.84-1.48C168.94,398.78,169,398.6,169.07,398.61Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '187.68px 400.813px 0px',
          }}
          id="el9l36womnt27"
          className="animable"
        />
        <path
          d="M238.81,251.24a76.62,76.62,0,0,0-12.22,5.69.14.14,0,1,0,.11.25c4.12-1.77,8.32-3.46,12.33-5.45A.27.27,0,0,0,238.81,251.24Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '232.821px 254.217px 0px',
          }}
          id="elt3x9ila367j"
          className="animable"
        />
        <path
          d="M240.12,223c0-.14-.26-.17-.26,0,0,4.89-.28,9.19-.69,13.76-.19,2.12-1.9,13.84-5.58,13-.61-.15-.93-.75-1-1.68a14.24,14.24,0,0,1,.49-3.59c.4-2.46.73-4.92.94-7.4a66.3,66.3,0,0,0-.15-13.87.12.12,0,1,0-.23,0,128.9,128.9,0,0,1-1.12,19.14c-.46,3-2,7.64,1.19,8.11s5.35-7.21,5.74-9.32A70.19,70.19,0,0,0,240.12,223Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '236.083px 236.687px 0px',
          }}
          id="elze5um9pu1e"
          className="animable"
        />
        <path
          d="M233.69,250a21.09,21.09,0,0,0-.83,2.43,5.72,5.72,0,0,0-.34,2,.15.15,0,0,0,.26.06,7.08,7.08,0,0,0,.85-1.95c.28-.75.58-1.5.83-2.26A.41.41,0,0,0,233.69,250Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '233.5px 252.144px 0px',
          }}
          id="elcjyf3uuqo7o"
          className="animable"
        />
        <path
          d="M201.65,219.62a39.22,39.22,0,0,0-5.15,14.24A43.85,43.85,0,0,0,197,249.1a33.48,33.48,0,0,1,.69,8.93c-.22,3.06-.63,6.1-1,9.15q-1,9-2,17.91c-1.32,11.89-2.53,23.81-4.09,35.67A147,147,0,0,1,187.34,338c-1.44,5.62-3.15,11.16-4.87,16.7-3.54,11.42-7.11,22.84-10.51,34.3-.43,1.44-.85,2.87-1.25,4.31,0,.12.14.16.18,0,3.86-11.26,7.26-22.69,10.83-34,3.49-11.11,7-22.18,8.85-33.7.92-5.87,1.55-11.77,2.22-17.67s1.36-11.94,2-17.91,1.35-11.82,2-17.73l1-8.95a63.69,63.69,0,0,0,.62-8.61,66.83,66.83,0,0,0-1.25-8.44,39.41,39.41,0,0,1-.45-7.82,40.69,40.69,0,0,1,3.65-15.19c.53-1.18.83-2.4,1.47-3.52C202,219.5,201.84,219.31,201.65,219.62Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '186.306px 306.438px 0px',
          }}
          id="el2neadn4ezbj"
          className="animable"
        />
        <path
          d="M215.51,221.61c-.75,2-1.61,3.94-2.53,5.86a14.81,14.81,0,0,1-3.13,4.75,11.75,11.75,0,0,1-4.76,2.41,26.19,26.19,0,0,1-3.07.67,22.09,22.09,0,0,0-3.13.57.21.21,0,0,0,0,.4,13.56,13.56,0,0,0,3.37.09,19.46,19.46,0,0,0,3.22-.43,11.69,11.69,0,0,0,5.2-2.66,13.83,13.83,0,0,0,3.18-5.19,33.9,33.9,0,0,0,1.91-6.4A.14.14,0,0,0,215.51,221.61Z"
          style={{
            fill: 'rgb(55, 71, 79)',
            transformOrigin: '207.257px 228.984px 0px',
          }}
          id="elmwhfnexquja"
          className="animable"
        />
        <path
          d="M244,206.25l1.76,11.09-48.29-.1s1.38-35.64,14.89-49.46c6.76-6.91,14.43-6.15,19.18-1,1.2,1.29,15.41,18.77,16.74,26.28C249.39,199.66,244,206.25,244,206.25Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '222.95px 190.049px 0px',
          }}
          id="el5w9f1nr63v4"
          className="animable"
        />
        <path
          d="M211.46,169.57a.85.85,0,0,1-.85.85.76.76,0,0,1-.44-.13c.34-.45.69-.88,1.05-1.3A.81.81,0,0,1,211.46,169.57Zm6-.86a.85.85,0,1,0,.85.85A.85.85,0,0,0,217.51,168.71Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,224.41,168.71Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,231.31,168.71ZM221,163.64a.85.85,0,1,0,.85.85A.85.85,0,0,0,221,163.64Zm6.45.13a.84.84,0,0,0-.4.72.85.85,0,0,0,1.7,0v0A10.78,10.78,0,0,0,227.41,163.77Zm-16.8,15.16a.85.85,0,1,0,.85.85A.85.85,0,0,0,210.61,178.93Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,217.51,178.93Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,224.41,178.93Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,231.31,178.93Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,238.21,178.93Zm-30.52-4.88c-.27.47-.53,1-.79,1.45a.58.58,0,0,0,.26.05.85.85,0,0,0,.85-.85A.81.81,0,0,0,207.69,174.05Zm6.37-.2a.85.85,0,1,0,.85.85A.85.85,0,0,0,214.06,173.85Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,221,173.85Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,227.86,173.85Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,234.76,173.85Zm-31,15.29a.85.85,0,1,0,.85.85A.85.85,0,0,0,203.71,189.14Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,210.61,189.14Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,217.51,189.14Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,224.41,189.14Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,231.31,189.14Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,238.21,189.14Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,245.11,189.14Zm-38-5.07a.85.85,0,1,0,.85.85A.85.85,0,0,0,207.16,184.07Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,214.06,184.07Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,221,184.07Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,227.86,184.07Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,234.76,184.07Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,241.66,184.07Zm-37.95,15.29a.85.85,0,1,0,.85.85A.85.85,0,0,0,203.71,199.36Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,210.61,199.36Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,217.51,199.36Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,224.41,199.36Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,231.31,199.36Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,238.21,199.36Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,245.11,199.36Zm-44.62-5c-.12.55-.24,1.1-.34,1.64h.11a.85.85,0,0,0,.85-.85A.83.83,0,0,0,200.49,194.33Zm6.67-.05a.85.85,0,1,0,.85.85A.85.85,0,0,0,207.16,194.28Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,214.06,194.28Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,221,194.28Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,227.86,194.28Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,234.76,194.28Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,241.66,194.28Zm6.71,0a.83.83,0,0,0-.66.81.84.84,0,0,0,.64.82A11.07,11.07,0,0,0,248.37,194.32Zm-44.66,15.25a.85.85,0,1,0,.85.85A.85.85,0,0,0,203.71,209.57Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,210.61,209.57Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,217.51,209.57Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,224.41,209.57Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,231.31,209.57Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,238.21,209.57Zm6.31.25a.84.84,0,0,0-.26.61.82.82,0,0,0,.47.75Zm-44.26-5.32a.85.85,0,1,0,.85.85A.85.85,0,0,0,200.26,204.5Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,207.16,204.5Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,214.06,204.5Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,221,204.5Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,227.86,204.5Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,234.76,204.5Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,241.66,204.5Zm-41.4,10.21a.85.85,0,1,0,.85.85A.85.85,0,0,0,200.26,214.71Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,207.16,214.71Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,214.06,214.71Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,221,214.71Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,227.86,214.71Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,234.76,214.71Zm6.9,0a.85.85,0,1,0,.85.85A.85.85,0,0,0,241.66,214.71Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '223.93px 190.02px 0px',
          }}
          id="elf43lh6lcg19"
          className="animable"
        />
        <path
          d="M235.84,202.71a53.39,53.39,0,0,0-7.63,1.32c-1.24.33-2.46.72-3.67,1.13-.61.21-1.22.39-1.83.57a7.82,7.82,0,0,1-2,.39c-.06,0-.05.09,0,.09a11.94,11.94,0,0,0,1.89-.05,14.1,14.1,0,0,0,1.81-.35c1.26-.33,2.5-.71,3.76-1,2.55-.68,5.08-1.36,7.67-1.85C236,202.9,236,202.7,235.84,202.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '228.314px 204.468px 0px',
          }}
          id="el564zjdjh8rb"
          className="animable"
        />
        <path
          d="M242.23,204.93a59.36,59.36,0,0,0-6.39-.25c-1.07,0-2.12.11-3.19.22-.5,0-1,.12-1.51.19s-1.1.22-1.66.29c-.06,0-.06.1,0,.09.53-.05,1.06,0,1.59,0l1.6-.06,3.18-.1c2.13-.09,4.25-.16,6.38-.18C242.35,205.11,242.34,204.94,242.23,204.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '235.876px 205.072px 0px',
          }}
          id="elz9663anf1k"
          className="animable"
        />
        <path
          d="M214.62,174.43c-3.77,5.69-21.58,28.09-22.25,30.24s3.38,6.61,3.34,7.48c-.16,3.57-9.12,25-12.31,22.77-4.19-3-19.12-21.81-17.13-31.74s40.32-34.66,46.58-37S218.34,168.82,214.62,174.43Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '191.788px 200.335px 0px',
          }}
          id="elmul2ipolznj"
          className="animable"
        />
        <path
          d="M200.15,242.6c2.42-2.28-1.66-3.82-1.66-3.82s6.4.8,8-2.51-3.47-4.89-3.83-5c.34,0,6.24.62,7.48-2.88s-4-4.46-4.35-4.52c.33-.06,4.7-1,5-3.84.58-4.93-12.14-3.4-15.35-5.83,0,0,.21-6.42.27-6.61a7.26,7.26,0,0,1-3.09,3.64c-2.61,1.22-5,2.07-5.89,3.57a3.64,3.64,0,0,0,.3,4.33s-3.52.17-4.59,2.89c-.54,1.4,1.21,3.51,1.21,3.51a4.35,4.35,0,0,0-3.61,2.73c-.64,2,1.22,3.79,1.22,3.79s-2.59,1.5-2.59,3.73C178.68,240.27,195,247.49,200.15,242.6Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '194.74px 225.912px 0px',
          }}
          id="el45l1vth68jn"
          className="animable"
        />
        <path
          d="M181.53,232.37c-.05,0-.1,0-.05.08a30.93,30.93,0,0,0,17.23,6.44c.19,0,.29-.31.07-.36A63.14,63.14,0,0,1,181.53,232.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '190.182px 235.63px 0px',
          }}
          id="el49w2adaiiqi"
          className="animable"
        />
        <path
          d="M183.58,225.52c-.06,0-.12.07-.06.11a28.93,28.93,0,0,0,19.23,5.86c.24,0,.44-.28.16-.28C198.21,231.27,188.63,228.29,183.58,225.52Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '193.271px 228.53px 0px',
          }}
          id="el5sn52vanapf"
          className="animable"
        />
        <path
          d="M206.24,223.65c-6.75.34-12.93-1.53-19-4.36-.08,0-.12.08-.06.13,2.59,2.19,6.65,3.59,9.9,4.41a17.75,17.75,0,0,0,9.18.06C206.38,223.86,206.39,223.65,206.24,223.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '196.751px 221.877px 0px',
          }}
          id="elne3i44qg4n"
          className="animable"
        />
        <path
          d="M181.1,232.06a4.29,4.29,0,0,1-1.69-4.16,3.23,3.23,0,0,1,1.29-1.84,5.67,5.67,0,0,1,2.55-.67,4.18,4.18,0,0,1-.84-4.67,3.16,3.16,0,0,1,1.83-1.4A10.45,10.45,0,0,1,187,219a3.68,3.68,0,0,1-1.31-3.07,4,4,0,0,1,2-3.07,19,19,0,0,1,4.11-1.7,9.9,9.9,0,0,0,2.09-1,4.22,4.22,0,0,0,1.55-1.93c.06-.13.08,0,0,.11a5.46,5.46,0,0,1-.86,1.46,6.83,6.83,0,0,1-1.32,1.2,30.12,30.12,0,0,1-3.88,1.87,5.69,5.69,0,0,0-2.72,2.52,3.42,3.42,0,0,0,.47,3.59c0,.05,0,.14-.08.14a9.87,9.87,0,0,0-2.36.68,3.35,3.35,0,0,0-1.51,1.32,4.41,4.41,0,0,0,.5,4.38,7.65,7.65,0,0,0-2.42,1.07,3.21,3.21,0,0,0-1,1.52,3.83,3.83,0,0,0,1,3.87.13.13,0,0,1,0,.05h0v0s0,0,0,.05h0s-.82.51-.87.52,0,0,0,0A5.84,5.84,0,0,1,181.1,232.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '187.422px 220.38px 0px',
          }}
          id="elzs04hd1wstq"
          className="animable"
        />
        <path
          d="M205,188.25l-15.79-8.75s16.1-10.68,23.57-13.74S220.38,169.92,205,188.25Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '203.457px 176.665px 0px',
          }}
          id="elcy8y8zuvz4k"
          className="animable"
        />
        <path
          d="M221.08,162.42c-2.55.89-3.33,2.68-2.65,4.83.76,2.39,7.8,7.32,10.88,5.91,2.67-1.22.7-7.55-.64-9A7.74,7.74,0,0,0,221.08,162.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '224.416px 167.74px 0px',
          }}
          id="ela3ekph9ylx"
          className="animable"
        />
        <path
          d="M219.2,166.73c.35.87,5.52,6.08,9.61,5.28,1.33-.27.21-7.6.21-7.6l0-.56.58-7.85-9.77-4.4-1.4-.56s0,2.15,0,4.84v.38c0,.15,0,.3,0,.44,0,.4,0,.81,0,1.22s0,.61,0,.94,0,.64,0,1A51.05,51.05,0,0,0,219.2,166.73Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '224.015px 161.567px 0px',
          }}
          id="elr49rtmmshu"
          className="animable"
        />
        <path
          d="M218.46,155.88a15.79,15.79,0,0,0,10.6,8l.58-7.85-9.77-4.4-1.4-.56S218.45,153.19,218.46,155.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '224.049px 157.475px 0px',
          }}
          id="elxidshsr4fcd"
          className="animable"
        />
        <path
          d="M239.38,144.29c1.35,13.73-6.73,16.09-9.69,16.38-2.69.26-11.88.8-14.64-12.72s3.21-18.49,9.33-19.42S238,130.55,239.38,144.29Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '226.944px 144.565px 0px',
          }}
          id="elee2wuh279wv"
          className="animable"
        />
        <path
          d="M235.94,140.84a7.46,7.46,0,0,1-.95-.1,1.48,1.48,0,0,1-.94-.29.48.48,0,0,1-.06-.6,1.22,1.22,0,0,1,1.16-.4,1.78,1.78,0,0,1,1.18.52A.52.52,0,0,1,235.94,140.84Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '235.189px 140.133px 0px',
          }}
          id="elxfxfg7ofdk"
          className="animable"
        />
        <path
          d="M226.67,142.11a7.35,7.35,0,0,0,.91-.28,1.59,1.59,0,0,0,.87-.47.51.51,0,0,0-.06-.6,1.21,1.21,0,0,0-1.22-.16,1.78,1.78,0,0,0-1.06.74A.52.52,0,0,0,226.67,142.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '227.28px 141.313px 0px',
          }}
          id="eld7tw9jwfg17"
          className="animable"
        />
        <path
          d="M229.31,145.29s-.06.05-.06.09c.15.93.15,2-.65,2.43,0,0,0,.06,0,.05C229.63,147.59,229.6,146.15,229.31,145.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '229.042px 146.576px 0px',
          }}
          id="el8uair14g83y"
          className="animable"
        />
        <path
          d="M228.36,144.42c-1.51.07-1.26,3.09.14,3S229.63,144.36,228.36,144.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '228.386px 145.921px 0px',
          }}
          id="el84wjff2kt4a"
          className="animable"
        />
        <path
          d="M227.78,144.63c-.25.19-.48.51-.8.57s-.67-.23-.93-.51c0,0-.05,0-.05,0,0,.58.31,1.15.94,1.19s.94-.52,1-1.11C228,144.7,227.88,144.55,227.78,144.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '226.978px 145.245px 0px',
          }}
          id="el2mb0h5e8yvv"
          className="animable"
        />
        <path
          d="M234.47,144.45s.07,0,.07.07c0,.94.25,2,1.12,2.26,0,0,0,.06,0,.05C234.61,146.77,234.35,145.34,234.47,144.45Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '235.052px 145.641px 0px',
          }}
          id="el733nqhnylzd"
          className="animable"
        />
        <path
          d="M235.23,143.41c1.5-.23,1.84,2.78.45,3S234,143.6,235.23,143.41Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '235.506px 144.909px 0px',
          }}
          id="el06ebbbtug3ra"
          className="animable"
        />
        <path
          d="M235.88,143.53c.26.13.53.4.81.38s.54-.37.72-.7c0,0,0,0,.05,0,.08.58,0,1.2-.58,1.37s-.93-.29-1.13-.85C235.71,143.65,235.78,143.48,235.88,143.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '236.612px 143.913px 0px',
          }}
          id="elkgqhoq8juqd"
          className="animable"
        />
        <path
          d="M229.78,152.88c.23.21.47.51.81.52a2.41,2.41,0,0,0,1-.27,0,0,0,0,1,0,.05,1.25,1.25,0,0,1-1.17.55,1,1,0,0,1-.77-.8C229.67,152.87,229.74,152.85,229.78,152.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '230.62px 153.302px 0px',
          }}
          id="elm5mnr5nptor"
          className="animable"
        />
        <path
          d="M233.37,149.13s.32,1.38.39,2c0,.06-.16.1-.38.14h0a3.17,3.17,0,0,1-3.16-.88.07.07,0,0,1,.09-.1,4.8,4.8,0,0,0,2.94.55c0-.19-.64-2.35-.53-2.36a5.71,5.71,0,0,1,1.53.19c-.6-2.89-1.65-5.66-2.2-8.55a.09.09,0,0,1,.17-.06,47.76,47.76,0,0,1,2.76,9.11C235.05,149.58,233.64,149.22,233.37,149.13Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '232.596px 145.693px 0px',
          }}
          id="elyir6ugbro8"
          className="animable"
        />
        <path
          d="M215.1,146.83c3.24-.07,3.06-5.19,3.06-5.19s3.67-.45,3.75-6.4a9,9,0,0,0,6.91,4.1c1.06.12-2.57-2.5-2.57-2.5s4.37,3.7,12.2,2c.55-.12-.31-9.22-6.58-11.86s-12.38,0-16.08,4c0,0-4.47,2.23-4.84,6.53S213.83,146.86,215.1,146.83Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '224.755px 136.374px 0px',
          }}
          id="ela6nrtdbglim"
          className="animable"
        />
        <path
          d="M227.24,150.52a4.45,4.45,0,1,1,4.24-5.6h0a4.45,4.45,0,0,1-3.15,5.44A4.56,4.56,0,0,1,227.24,150.52Zm-.1-8.3a3.45,3.45,0,0,0-.95.13,3.85,3.85,0,1,0,.95-.13Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '227.181px 146.07px 0px',
          }}
          id="elyk0fwielxe"
          className="animable"
        />
        <path
          d="M237.35,149.15c-1.7,0-3.27-1.7-3.56-4a5.22,5.22,0,0,1,.53-3.21,2.77,2.77,0,0,1,4.7-.61,5.29,5.29,0,0,1,1.33,3c.31,2.44-.9,4.6-2.71,4.84Zm-.55-8.26h-.23a2.36,2.36,0,0,0-1.73,1.33,4.76,4.76,0,0,0-.47,2.84c.28,2.11,1.7,3.66,3.19,3.47s2.47-2.06,2.2-4.17a4.69,4.69,0,0,0-1.17-2.63A2.48,2.48,0,0,0,236.8,140.89Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '237.064px 144.729px 0px',
          }}
          id="elz3y7f1gnwm9"
          className="animable"
        />
        <path
          d="M231.4,145.45l-.44-.4c.6-.65,2-1.61,3.27-.59l-.38.45C232.75,144,231.45,145.39,231.4,145.45Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '232.595px 144.732px 0px',
          }}
          id="elh349t0ocosn"
          className="animable"
        />
        <path
          d="M211.9,149.13l-.56-.2c.1-.26,1-2.56,2.25-2.94s9.2-.64,9.54-.65l0,.59c-2.29.08-8.46.35-9.39.63S212.13,148.5,211.9,149.13Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '217.235px 147.235px 0px',
          }}
          id="elt314i38156"
          className="animable"
        />
        <path
          d="M217.34,148.79s-3.06-4.27-5-3.18.39,7.32,2.69,8.15a2.35,2.35,0,0,0,3.12-1.29Z"
          style={{
            fill: 'rgb(247, 169, 160)',
            transformOrigin: '214.884px 149.693px 0px',
          }}
          id="elzd9zk8aaakb"
          className="animable"
        />
        <path
          d="M213.05,147.38s0,.05,0,.06a5.91,5.91,0,0,1,3.09,3.66,1.29,1.29,0,0,0-1.93-.33s0,.09,0,.08a1.44,1.44,0,0,1,1.59.48,7.54,7.54,0,0,1,.77,1.27c.08.15.33.07.28-.1l0,0C216.88,150.41,215.25,147.56,213.05,147.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '214.953px 150.03px 0px',
          }}
          id="el0gspwxadwqs"
          className="animable"
        />
      </g>
      <defs>
        {' '}
        <filter id="active" height="200%">
          {' '}
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />{' '}
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />{' '}
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />{' '}
          <feMerge>
            {' '}
            <feMergeNode in="OUTLINE" /> <feMergeNode in="SourceGraphic" />{' '}
          </feMerge>{' '}
        </filter>{' '}
        <filter id="hover" height="200%">
          {' '}
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />{' '}
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />{' '}
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />{' '}
          <feMerge>
            {' '}
            <feMergeNode in="OUTLINE" /> <feMergeNode in="SourceGraphic" />{' '}
          </feMerge>{' '}
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />{' '}
        </filter>
      </defs>
    </svg>
  );
};

export default AnimatedSvgImage;
